import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69848314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pro-sidebar-logo" }, [
    /*#__PURE__*/_createElementVNode("div", null, "vipa"),
    /*#__PURE__*/_createElementVNode("h5", null, "Model Zoo")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://pruning.vipazoo.cn/api/Cifar/0_93.jpg",
    alt: "Icon"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("  CIFAR10 "),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-suffix" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge primary" }, "classify")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://pruning.vipazoo.cn/api/Cifar/9_36064.jpg",
    alt: "Icon"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("  CIFAR100 "),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-suffix" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge primary" }, "classify")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://pruning.vipazoo.cn/api/VOC/2010_001499.jpg",
    alt: "Icon"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("  ImageNet "),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-suffix" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge primary" }, "classify")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://pruning.vipazoo.cn/api/VOC/2008_002789.jpg",
    alt: "Icon"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("  COCO "),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-suffix" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge secondary" }, "detect")
  ])
], -1))
const _hoisted_11 = { class: "sidebar-footer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-box" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "react-logo",
      src: "https://user-images.githubusercontent.com/25878302/213938106-ca8f0485-3f30-4861-9188-2920ed7ab284.png",
      alt: "react"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 10px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","margin-bottom":"10px","color":"white"} }, "PruningBench is continually benchmarking more models! "),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/HollyLee2000/PruningBench",
        target: "_blank"
      }, "Check it out!")
    ])
  ])
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "holly" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "tree-container" })
], -1))
const _hoisted_15 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_16 = { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#000096"} }
const _hoisted_17 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Drop file here or "),
  /*#__PURE__*/_createElementVNode("em", null, "click to upload")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " checkpoint file with a size less than 500MB ", -1))
const _hoisted_20 = {
  key: 1,
  style: {"margin":"20px 0 20px 0","text-align":"left"}
}
const _hoisted_21 = { style: {"margin":"20px 0 20px 0","text-align":"left"} }
const _hoisted_22 = { style: {"margin":"20px 0 20px 0","text-align":"center"} }
const _hoisted_23 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#800E25","word-wrap":"break-word","white-space":"pre-wrap"} }, " Testing......", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#20BD1C","word-wrap":"break-word","white-space":"pre-wrap"} }, " Success!", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#800E25","word-wrap":"break-word","white-space":"pre-wrap"} }, " Pruning......", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#20BD1C","word-wrap":"break-word","white-space":"pre-wrap"} }, " Pruned!", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_36 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_37 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_38 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_39 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_40 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_41 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_42 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_43 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_44 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_47 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_50 = { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { style: {"margin":"0 0 20px 0","text-align":"center"} }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#000096"} }, "CIFAR Tips: Complete the following information and submit a pruning task.")
], -1))
const _hoisted_54 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_55 = { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#800E25"} }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step1: Choose whether to employ sparse learning. Sparse learning is often time-consuming and does not guarantee benefits.")
], -1))
const _hoisted_64 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_65 = {
  key: 0,
  style: {"margin":"0 0 20px 0","text-align":"left"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Input the number of epochs for sparse learning (Integer required and 100 is recommend, other hyperparameters have been set to optimal).", -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  key: 1,
  style: {"margin":"0 0 20px 0","text-align":"left"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step2: Select the pruner, i.e., importance criterion + sparsity regularizer (if sparse learning is employed).")
], -1))
const _hoisted_70 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_71 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_72 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#800E25","word-wrap":"break-word","white-space":"pre-wrap"} }, "Complete Step1 first.", -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step3: Choose batch size for sparse learning, evaluation and finetuning. It is recommended to choose 128, but if the task fails, you could choose a smaller one.")
], -1))
const _hoisted_76 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step4: Enter the minimum desired speedup for the pruned model in terms of FLOPs. This must be a number greater than 1 but not exceeding 10.")
], -1))
const _hoisted_78 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step5: Set the number of iterations for pruning, and 400 is recommended. Increasing the number of pruning iterations facilitates precise acceleration to the target speed in terms of Flops and improve pruning performance. However, for models and methods that are particularly slow in pruning (such as mobileNet and Inception with group convolutions; Taylor and Hessian importance that rely on gradients), you can lower this value accordingly.")
], -1))
const _hoisted_80 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step6: Choose whether to fine-tune. ")
], -1))
const _hoisted_82 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step7: Choose experimental environment (CIFAR experiments do not need DDP acceleration).")
], -1))
const _hoisted_84 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step8: Input the number of epochs for finetuning (Integer required and 100 is recommend, other hyperparameters have been set to optimal).")
], -1))
const _hoisted_86 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step9: Select the client and submit the pruning task that needs fine-tuning.")
], -1))
const _hoisted_88 = { style: {"margin":"0 0 30px 0","text-align":"left","width":"100%"} }
const _hoisted_89 = { style: {"display":"flex","flex-direction":"column","width":"40%"} }
const _hoisted_90 = ["id"]
const _hoisted_91 = { style: {"display":"flex","flex-direction":"column","width":"40%"} }
const _hoisted_92 = ["id"]
const _hoisted_93 = { style: {"margin":"0 0 20px 0","text-align":"center"} }
const _hoisted_94 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_95 = {
  key: 0,
  style: {"color":"darkred"}
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#000096"} }, "COCO Tips: Complete the following information and submit a pruning task.")
], -1))
const _hoisted_98 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_99 = { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#800E25"} }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step1: Choose whether to employ sparse learning. Sparse learning is often time-consuming and does not guarantee benefits.")
], -1))
const _hoisted_108 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_109 = {
  key: 0,
  style: {"margin":"0 0 20px 0","text-align":"left"}
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Input the number of epochs for sparse learning (Integer required and 100 is recommend, other hyperparameters have been set to optimal).", -1))
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = {
  key: 1,
  style: {"margin":"0 0 20px 0","text-align":"left"}
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step2: Select the pruner, i.e., importance criterion + sparsity regularizer (if sparse learning is employed).")
], -1))
const _hoisted_114 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_115 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_116 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#800E25","word-wrap":"break-word","white-space":"pre-wrap"} }, "Complete Step1 first.", -1))
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step3: Choose batch size for sparse learning, evaluation and finetuning. It is recommended to choose 128, but if the task fails, you could choose a smaller one.")
], -1))
const _hoisted_120 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step4: Enter the minimum desired speedup for the pruned model in terms of FLOPs. This must be a number greater than 1 but not exceeding 10.")
], -1))
const _hoisted_122 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step5: Set the number of iterations for pruning, and 400 is recommended. Increasing the number of pruning iterations facilitates precise acceleration to the target speed in terms of Flops and improve pruning performance. However, for models and methods that are particularly slow in pruning (such as mobileNet and Inception with group convolutions; Taylor and Hessian importance that rely on gradients), you can lower this value accordingly.")
], -1))
const _hoisted_124 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step6: Choose whether to fine-tune. ")
], -1))
const _hoisted_126 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step7: Choose experimental environment (COCO experiments do not support DDP acceleration yet).")
], -1))
const _hoisted_128 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step8: Input the number of epochs for finetuning (Integer required and 90 is recommend, other hyperparameters have been set to optimal).")
], -1))
const _hoisted_130 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step9: Select the client and submit the pruning task that needs fine-tuning.")
], -1))
const _hoisted_132 = { style: {"margin":"0 0 30px 0","text-align":"left","width":"100%"} }
const _hoisted_133 = { style: {"display":"flex","flex-direction":"column","width":"40%"} }
const _hoisted_134 = ["id"]
const _hoisted_135 = { style: {"display":"flex","flex-direction":"column","width":"40%"} }
const _hoisted_136 = ["id"]
const _hoisted_137 = { style: {"margin":"0 0 20px 0","text-align":"center"} }
const _hoisted_138 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#000096"} }, "ImageNet Tips: Complete the following information and submit a pruning task.")
], -1))
const _hoisted_140 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_141 = { style: {"margin-left":"50px","font-size":"18px","border":"0","word-wrap":"break-word","white-space":"pre-wrap","color":"#800E25"} }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step1: Choose whether to employ sparse learning. Sparse learning is often time-consuming and does not guarantee benefits.")
], -1))
const _hoisted_150 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_151 = {
  key: 0,
  style: {"margin":"0 0 20px 0","text-align":"left"}
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Input the number of epochs for sparse learning (Integer required and 100 is recommend, other hyperparameters have been set to optimal).", -1))
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = {
  key: 1,
  style: {"margin":"0 0 20px 0","text-align":"left"}
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step2: Select the pruner, i.e., importance criterion + sparsity regularizer (if sparse learning is employed).")
], -1))
const _hoisted_156 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_157 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_158 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_159 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_160 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"#800E25","word-wrap":"break-word","white-space":"pre-wrap"} }, "Complete Step1 first.", -1))
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step3: Choose batch size for sparse learning, evaluation and finetuning. It is recommended to choose 128, but if the task fails, you could choose a smaller one.")
], -1))
const _hoisted_164 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step4: Enter the minimum desired speedup for the pruned model in terms of FLOPs. This must be a number greater than 1 but not exceeding 10.")
], -1))
const _hoisted_166 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step5: Set the number of iterations for pruning, and 400 is recommended. Increasing the number of pruning iterations facilitates precise acceleration to the target speed in terms of Flops and improve pruning performance. However, for models and methods that are particularly slow in pruning (such as mobileNet and Inception with group convolutions; Taylor and Hessian importance that rely on gradients), you can lower this value accordingly.")
], -1))
const _hoisted_168 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step6: Choose whether to fine-tune. ")
], -1))
const _hoisted_170 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step7: Choose experimental environment.")
], -1))
const _hoisted_172 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step8: Input the number of epochs for finetuning (Integer required and 90 is recommend, other hyperparameters have been set to optimal).")
], -1))
const _hoisted_174 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"50px","font-size":"18px","border":"0","color":"black","word-wrap":"break-word","white-space":"pre-wrap"} }, "Step9: Select the client and submit the pruning task that needs fine-tuning.")
], -1))
const _hoisted_176 = { style: {"margin":"0 0 30px 0","text-align":"left","width":"100%"} }
const _hoisted_177 = { style: {"display":"flex","flex-direction":"column","width":"40%"} }
const _hoisted_178 = ["id"]
const _hoisted_179 = { style: {"display":"flex","flex-direction":"column","width":"40%"} }
const _hoisted_180 = ["id"]
const _hoisted_181 = { style: {"margin":"0 0 20px 0","text-align":"center"} }
const _hoisted_182 = { style: {"margin":"0 0 20px 0","text-align":"left"} }

import { UploadFilled } from '@element-plus/icons-vue'
import * as echarts from 'echarts'
import {ElMessage, UploadInstance, UploadProps} from "element-plus";
import {getCurrentInstance, onBeforeUnmount, ref, watch} from 'vue';
import axios from "axios";
import {useStore} from "vuex";
import request from "@/api";
import {router} from "@/router";

import $ from 'jquery'
import * as d3 from 'd3';
import { reactive, onMounted} from "vue";
import '@fortawesome/fontawesome-free/css/all.css'
import request2 from "@/api";

import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
} from '@element-plus/icons-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'pruning',
  setup(__props) {

const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

const myIcon = ref('<')
const myIcon2 = ref('>')
const resultLoading4 = ref(false)
const flag_prune_done = ref(false)  //是否剪枝完成
const resultShow_tree_result = ref(false)  //剪枝完的结果是否展示

const isCollapse = ref(true)

const isCollapseDiv = ref(true)

const percentage = ref(0)
const percentage2 = ref(0)
const colors = [
  { color: '#20BD1C', percentage: 20 },
  { color: '#5cb87a', percentage: 40 },
  { color: '#e6a23c', percentage: 60 },
  { color: '#f56c6c', percentage: 80 },
  { color: '#FE0A10', percentage: 100 },
]

// 使用ref创建一个变量，用于记录已上传的文件

const structureBeforePruned = ref('')
const structureAfterPruned = ref('')
const logPath = ref('')
const uploadType = ref('')

const isPruned = ref(false)

// const isTest = ref(false)


const modelType = ref('')
const modelTypeSimple = ref('')
const modelPath = ref('')
const modelAcc = ref(0)
const modelParams = ref('')
const modelFlops = ref('')
const modelName = ref('')
const modelDataset = ref('')

const modelDatasetSimple = ref('')

const paramsChange = ref('')
const FLOPsChange = ref('')
const AccChange = ref('')
const LossChange = ref('')

const PrunedPath = ref('')
const ckpt = ref('')

const usrModelName = ref('')
const script = ref('')
const speedup = ref()
const batchsize = ref(0)
const finetune = ref('')
const criterion = ref('')
const radio1 = ref('wosl')
const finetunemode = ref('DDP')
const INtype = ref('cnn')
const PrunedialogVisible = ref(false);
const LeafNodeVisible = ref(false);
const PruneCOCOdialogVisible = ref(false);
const ImageNetPrunedialogVisible = ref(false);
const uploadRef = ref<UploadInstance>();
const uploadRef2 = ref<UploadInstance>();
const uploadRef3 = ref<UploadInstance>();
const uploadFileList = ref([]);
const uploadFileList2 = ref([]);
const uploadFileList3 = ref([]);
const store = useStore();
const userQuery = ref('')
const Email = ref('')
const Infos = ref('')
const morf = ref('')
const lerf = ref('')
const client = ref('')
const gpuName = ref('')
const gpuTotMem = ref(0)
const gpuRemainMem = ref(0)
const gpuInfos = ref();
const pythonValue = ref('')
const servers = ref([])
const servers2 = ref([])
const currentPage = ref(1)
const currentPage2 = ref(1)
const perPage = ref(8)
// const perPage2 = ref(8)
const score = ref(0.0)
const rank = ref(666)
let resultLoading = ref(false)
let resultShow = ref(false)
const morfUploaded = ref(false)
const lerfUploaded = ref(false)
const pythonUploaded = ref(false)
const lr = ref(0)
// const lerfUploaded = ref(false)
let checkCsv = ref(false)
let checkCsv2 = ref(false)
let checkPython = ref(false)


const { proxy: ctx } = getCurrentInstance()




//
// //初始化图表
// let myChart = echarts.init(document.getElementById('gpuChart') );
// //配置图表的参数
// let option = {
//   title: {
//     text:'扇形图示例'
//   },
//   series : [
//     {
//       name:'数据',
//       type: 'pie' ,
//       radius: '50%',
//       data: [
//           {value: 335,  name:'数据1'},
//           {value: 310,  name:'数据2'},
//           {value: 234,  name:'数据3'}
//       ]
//     }
//   ]
// };
// //使用配置项显示图表
// myChart.setOption(option);



const style = ref({
  pagination: {
    marginTop: '20px'
  },
  down: {
    marginBottom: '20px'
  }
})


const fields = ref([
  {
    key: 'ranking',
    label: 'Ranking',
    class: 'text-center'
  },
  {
    key: 'username',
    label: 'contributor',
    sortable: true,
    class: 'text-center'
  },
  {
    key: 'institute',
    label: 'institute',
    sortable: true,
    class: 'text-center'
  },
  {
    key: 'name',
    label: 'algorithm',
    class: 'text-center'
  },
  {
    key: 'score',
    label: 'metascore',
    stickyColumn: true,
    class: 'text-center'
  }
])

var nodes;
var dragStarted;
var domNode;

const jumpOut = ref(false);
const UploadVisible = ref(false);
const scriptVisible = ref(false);
const dialogVisible = ref(false);
const dialogVisible2 = ref(false);
const dialogVisible_interp = ref(false);
const dialogVisible_atenhoc = ref(false);
const dialogVisible_posthoc = ref(false);
const dialogVisible_local = ref(false);
const dialogVisible_global = ref(false);
const dialogVisible_attention = ref(false);
const dialogVisible_tree = ref(false);
const dialogVisible_intro_concept = ref(false);
const dialogVisible_intro_constituent = ref(false);
const resultLoading2 = ref(false)
const ckptUploaded = ref(false)
const modelzoo = ref();
const epoch = ref();
const sl_total_epochs = ref();
const iterative_steps = ref();
const optionList = []
const client155_1_form = ref('Pie');
const client155_2_form = ref('Pie');
const client155_form = ref('Pie')



const cascader_value = ref([])

const cascader_props = {
  expandTrigger: 'hover' as const,
}

//cascader
const handleCascaderChange = async (value) => {
  console.log("value: ", value)
  if(value[0].type=='upload'){
    console.log('这是一个上传模型的任务')
    ckpt.value = ''
    ckptUploaded.value = false
    uploadType.value = ''
    modelName.value = cascaderModel
    usrModelName.value = ''
    console.log("d.parent.parent.name", cascaderDataset)
    if(cascaderDataset==="CIFAR10"||cascaderDataset==="CIFAR100"||cascaderDataset==="ImageNet"){
      structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
          cascaderDataset.toLowerCase()+'_'+cascaderModel.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
      modelDataset.value = cascaderDataset + " (Classification)"
      modelDatasetSimple.value = cascaderDataset
    }else if(cascaderDataset==="COCO"){
      modelDataset.value = cascaderDataset + " (Detection)"
      modelDatasetSimple.value = cascaderDataset
    }
    console.log("modelName.value: ", modelName.value)
    console.log("modelDatasetSimple.value: ", modelDatasetSimple.value)
    UploadVisible.value = true

  }else if(value[0]=='prune_user' || value[0].type=='pretrained'){
    console.log('这是一个剪枝模型的任务')
    let currentTarget;
    if(value[0]=='prune_user'){
      console.log('剪得是用户的模型')
      currentTarget = value[1]
      modelType.value = "User trained model"
      modelTypeSimple.value = value[1].name
    }else if(value[0].type=='pretrained'){
      console.log('剪的是预训练的模型')
      currentTarget = value[0];
      modelType.value = "Publicly pretrained model"
      modelTypeSimple.value = "Pretrain"
    }
    radio1.value = 'wosl'  //要不要sparse learing
    criterion.value = ''  //重要性指标
    batchsize.value = 0
    client155_form.value = 'Bar'
    speedup.value = ''
    finetune.value = ''
    epoch.value = null
    client.value = ''
    iterative_steps.value = ''
    sl_total_epochs.value = ''
    scriptVisible.value = false

    if(cascaderDataset==="CIFAR10"||cascaderDataset==="CIFAR100"||cascaderDataset==="ImageNet"){
      modelDataset.value = cascaderDataset + " (Classification)"
      modelDatasetSimple.value = cascaderDataset
    }else if(cascaderDataset==="COCO"){
      modelDataset.value = cascaderDataset + " (Detection)"
      modelDatasetSimple.value = cascaderDataset
    }
    console.log("modelDataset.value", modelDataset.value)



    console.log("d.path", currentTarget.path)
    modelPath.value = currentTarget.path
    console.log("d.acc", currentTarget.acc)
    modelAcc.value = currentTarget.acc
    console.log("d.params", currentTarget.params)
    modelParams.value = currentTarget.params
    console.log("d.flops", currentTarget.flops)
    modelFlops.value = currentTarget.flops
    // console.log("d.parent.name", value[0].parent.name)
    modelName.value = cascaderModel
    // console.log("d.parent.parent.name", value[0].parent.parent.name)


    structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
        cascaderDataset.toLowerCase()+'_'+cascaderModel.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
    console.log("structureBeforePruned", structureBeforePruned.value)


    if(cascaderDataset=='CIFAR100' || cascaderDataset=='CIFAR10'){
      PrunedialogVisible.value = true


      // await axios
      //     .post(`/user/getStructureBeforePruned`, {
      //     })
      //     .then((response) => {
      //       let ranks = response.data.data.ranklistinfo
      //       console.log("response.data.data", response.data.data)
      //       console.log("ranks: ", ranks)
      //       servers.value = ranks
      //     })
      //     .catch((errors) => {
      //       console.log('error', errors)
      //     })


      // ElMessage.success("选择了预训练模型！")
    }else if(cascaderDataset=='ImageNet'){
      ImageNetPrunedialogVisible.value = true
      // console.log("d.type", d.type)
      if(cascaderModel.includes('hf')){
        INtype.value = 'hf';
      }else if(cascaderModel.includes('timm')){
        INtype.value = 'timm';
      }else{
        INtype.value = 'cnn';
      }

      if(currentTarget.model_name=='ImageNet_ResNet50_Pretrained' || currentTarget.model_name=='ImageNet_DenseNet121_Pretrained'){
        lr.value = 0.08
      }else if(currentTarget.model_name=='ImageNet_MobileNetV2_Pretrained'){
        lr.value = 0.045
      }else if(currentTarget.model_name=='ImageNet_VGG19-BN_Pretrained' || currentTarget.model_name=='ImageNet_VGG16-BN_Pretrained'){
        lr.value = 0.01
      }
      // radio1.value = 'wosl'
      // criterion.value = ''
      // batchsize.value = 0
      // speedup.value = ''
      // finetune.value = ''
      // scriptVisible.value = false

      // if(value[0].type==='pretrained'){
      //   modelType.value = "Publicly pretrained model"
      //   modelTypeSimple.value = "Pretrain"
      // }else if(value[0].type==='usr'){
      //   modelType.value = "User trained model"
      //   modelTypeSimple.value = value[0].name
      // }
      //
      // console.log("d.path", value[0].path)
      // modelPath.value = value[0].path
      // console.log("d.acc", value[0].acc)
      // modelAcc.value = value[0].acc
      // console.log("d.params", value[0].params)
      // modelParams.value = value[0].params
      // console.log("d.flops", value[0].flops)
      // modelFlops.value = value[0].flops
      // console.log("d.parent.name", value[0].parent.name)
      // modelName.value = cascaderModel


      // console.log("d.parent.parent.name", cascaderDataset)
      // if(cascaderDataset==="CIFAR10"||cascaderDataset==="CIFAR100"||cascaderDataset==="ImageNet"){
      //   modelDataset.value = cascaderDataset + " (Classification)"
      //   modelDatasetSimple.value = cascaderDataset
      // }else if(cascaderDataset==="COCO"){
      //   modelDataset.value = cascaderDataset + " (Detection)"
      //   modelDatasetSimple.value = cascaderDataset
      // }


      // structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
      //     cascaderDataset.toLowerCase()+'_'+cascaderModel.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
      // console.log("structureBeforePruned", structureBeforePruned.value)


    }else if(cascaderDataset=='COCO'){
      // radio1.value = 'wosl'  //要不要sparse learing
      // criterion.value = ''  //重要性指标
      // batchsize.value = 0
      // speedup.value = ''
      // finetune.value = ''
      // scriptVisible.value = false
      PruneCOCOdialogVisible.value = true
      console.log("d.type", currentTarget.type)
      // if(value[0].type==='pretrained'){
      //   modelType.value = "Publicly pretrained model"
      //   modelTypeSimple.value = "Pretrain"
      // }else if(value[0].type==='usr'){
      //   modelType.value = "User trained model"
      //   modelTypeSimple.value = value[0].name
      // }
      //
      // console.log("d.path", value[0].path)
      // modelPath.value = value[0].path
      // console.log("d.acc", value[0].acc)
      // modelAcc.value = value[0].acc
      // console.log("d.params", value[0].params)
      // modelParams.value = value[0].params
      // console.log("d.flops", value[0].flops)
      // modelFlops.value = value[0].flops
      // console.log("d.parent.name", cascaderModel)
      // modelName.value = cascaderModel


      // console.log("d.parent.parent.name", cascaderDataset)
      // if(cascaderDataset==="CIFAR10"||cascaderDataset==="CIFAR100"||cascaderDataset==="ImageNet"){
      //   modelDataset.value = cascaderDataset + " (Classification)"
      //   modelDatasetSimple.value = cascaderDataset
      // }else if(cascaderDataset==="COCO"){
      //   modelDataset.value = cascaderDataset + " (Detection)"
      //   modelDatasetSimple.value = cascaderDataset
      // }
      // console.log("modelDataset.value", modelDataset.value)

      // structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
      //     cascaderDataset.toLowerCase()+'_'+cascaderModel.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
      //
      //
      // console.log("structureBeforePruned", structureBeforePruned.value)
    }else{
      console.log("标记d.parent.parent.name: ", cascaderDataset)
    }

    //gpuChartRef
    await request.post('/algorithm/gpuInfoList')
        .then((response)=>{
          console.log(response)
          let originGPUs=response.data.data
          console.log("originGPUs: ", originGPUs)
          gpuInfos.value = originGPUs
          for(let i=0; i<originGPUs.length; i++){
            let option = {
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c}MiB ({d}%)",
                confine: false,
                appendToBody: true,
                // position: function(point, e, dom, size) {
                //   // 1.计算出绘制canvas的容器（dom.parentNode的值）相对于页面顶部的高度。注意需要由相对于浏览器窗口上部的距离 加上 页面卷曲的高度 来计算。
                //   var top = dom.parentNode.getBoundingClientRect().top + (window.scrollY ? window.scrollY : window.pageYOffset)
                //   // 2.计算出canvas外容器相对与浏览器窗口的左侧的距离
                //   var left = dom.parentNode.getBoundingClientRect().left
                //   // 3.因为tooltip内容过多，canvas已经放不下tooltip。所以需要改变tooltip的定位方式为fixed。
                //   dom.style.position = 'fixed'
                //   // 4.计算出left
                //   var resultLeft = point[0] + left + 5 + dom.clientWidth > document.body.clientWidth ? document.body.clientWidth - dom.clientWidth - 20 : point[0] + left + 5
                //   // 5.计算出top
                //   var resultTop = (point[1] + top + dom.clientHeight) < document.body.clientHeight ? point[1] + dom.parentNode.getBoundingClientRect().top : dom.parentNode.getBoundingClientRect().top - dom.clientHeight + point[1]
                //   // 6.返回位置数据 [left, top]
                //   return [resultLeft, resultTop]
                // },

              },
              color:['#ef6567', '#3BA272'],
              series : [
                {
                  name:originGPUs[i].name+' GPU information',
                  type: 'pie' ,
                  radius: '70%',
                  data: [
                    {value: originGPUs[i].tot_memory - originGPUs[i].remain_memory,  name:'Used'},
                    {value: originGPUs[i].remain_memory,  name:'Available'},
                  ],
                  center: ["50%", "50%"],  // 调整饼图中心点位置
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                }
              ]
            }
            optionList.push(option);
          }
          // gpuChart_


          // gpuRemainMem.value = originGPUs.remain_memory
          // gpuTotMem.value = originGPUs.tot_memory
          // console.log("gpuRemainMem: ", gpuRemainMem.value)
          // console.log("gpuTotMem: ", gpuTotMem.value)
        })
        .catch((error)=>{
          console.error(error)
        })

  }else{
    console.log('这是未知类型的任务,出错了吧!')
  }

  LeafNodeVisible.value = false
}

var cascader_options = [
  {
    value: 'upload',
    label: 'Upload a raw model',
  },
  {
    value: 'prune_pretrained',
    label: 'Prune a pretrained model',
  },
  {
    value: 'prune_user',
    label: 'Prune a user-trained model',
    disabled: true,
  },
]


// dialogVisible_global

const activeTab = ref('cn')

//gpuChartRef

// 监听 finetune 变量的变化
// watch(finetune, (newValue, oldValue) => {
//   if (newValue === 'True') {
//     // 执行 finetune 为 True 时的操作
//     console.log('finetune 变为 True，执行操作...');
//     setTimeout(() => {
//       //初始化图表
//       for(let i=0; i<optionList.length; i++){
//         let myChart = echarts.init(document.getElementById('gpuChart_'+i));
//         myChart.setOption(optionList[i]);
//       }
//     }, 200)  //要延迟200毫秒才能挂载
//   }
// });

watch(client155_form, (newValue, oldValue) => {
  if (newValue === 'Pie') {
    // 执行 finetune 为 True 时的操作
    console.log('设定为Pie，执行操作...');
    setTimeout(() => {
      //初始化图表
      for(let i=0; i<optionList.length; i++){
        let myChart = echarts.init(document.getElementById('gpuChart_'+i));
        myChart.setOption(optionList[i]);
      }
    }, 200)  //要延迟200毫秒才能挂载
  }
});

watch(client155_form, (newValue, oldValue) => {
  if (newValue === 'Pie') {
    // 执行 finetune 为 True 时的操作
    console.log('设定为Pie，执行操作...');
    setTimeout(() => {
      //初始化图表
      for(let i=0; i<optionList.length; i++){
        let myChart2 = echarts.init(document.getElementById('gpuChart2_'+i));
        myChart2.setOption(optionList[i]);
      }
    }, 200)  //要延迟200毫秒才能挂载
  }
});

// watch(client155_2_form, (newValue, oldValue) => {
//   if (newValue === 'Pie') {
//     // 执行 finetune 为 True 时的操作
//     console.log('设定为Pie，执行操作...');
//     setTimeout(() => {
//       //初始化图表
//       for(let i=0; i<optionList.length; i++){
//         let myChart2 = echarts.init(document.getElementById('gpuChart2_'+i));
//         myChart2.setOption(optionList[i]);
//       }
//     }, 200)  //要延迟200毫秒才能挂载
//   }
// });

function toggleCollapse () {
  // if(isCollapse.value){
  //   myIcon.value = '<'
  // }else{
  //   myIcon.value = '>'
  // }
  isCollapse.value = !isCollapse.value
  // //等待半秒钟
  // isCollapseDiv.value = isCollapseDiv.value != true;

  isCollapseDiv.value = !isCollapseDiv.value;


  // 等待半秒钟
  // setTimeout(() => {
  //   isCollapseDiv.value = !isCollapseDiv.value;
  // }, 500); // 500毫秒等待时间
}

function showDialog() {
  console.log("进来了")
  dialogVisible.value = true;
}
function showDialog_interp() {
  // console.log("进来了")
  dialogVisible_interp.value = true;
}
function showDialog_atenhoc() {
  // console.log("进来了")
  dialogVisible_atenhoc.value = true;
}
function showDialog_posthoc() {
  // console.log("进来了")
  dialogVisible_posthoc.value = true;
}
function showDialog_local() {
  // console.log("进来了")
  dialogVisible_local.value = true;
}
function showDialog_global() {
  // console.log("进来了")
  dialogVisible_global.value = true;
}
function showDialog_attention() {
  // console.log("进来了")
  dialogVisible_attention.value = true;
}
function showDialog_tree() {
  // console.log("进来了")
  dialogVisible_tree.value = true;
}
function showDialog_intro_concept() {
  // console.log("进来了")
  dialogVisible_intro_concept.value = true;
}
function showDialog_intro_Constituent() {
  // console.log("进来了")
  dialogVisible_intro_constituent.value = true;
}

// const getModelZoo = () => {
//   request2.post(`/user/getModelZoo`, {
//   })
//       .then((response) => {
//         let ranks = response.data
//         // console.log("response.data.data", response.data.data)
//         console.log("ranks: ", ranks)
//         // ranks = ranks.map(addSelectField)
//         // for (let rank of ranks) {
//         //     rank.link = '详情'
//         // }
//         // console.log('getranks')
//         modelzoo.value = ranks
//       })
//       .catch((errors) => {
//         console.log('error', errors)
//       })
// }

//
//OnlinePruning
const SubmitTask = async () => {

  console.log("localStorage.getItem('userTicket'): ", localStorage.getItem('userTicket'))
  console.log("localStorage.getItem('access'): ", localStorage.getItem('access'))

  let tempScript
  console.log("speedup.value:", speedup.value)
  // let flag = true
  if (radio1.value != 'sl' && radio1.value != 'wosl') {
    ElMessage.error("Choose whether to employ sparse learning!")
  } else if (radio1.value === 'sl' && finetune.value !== 'True') {
    ElMessage.error("If sparse training is selected, fine-tuning must be selected as well!")
  } else if (criterion.value === '') {
    ElMessage.error("Select the pruner!")
  } else if (batchsize.value === 0) {
    ElMessage.error("Choose the batch size for sparse learning, evaluation and finetuning!")
  } else if (speedup.value <= 1 || speedup.value > 10 || speedup.value === undefined || speedup.value === '') {
    ElMessage.error("Speedup must be a number greater than 1 and not exceeding 10!")
  } else if (radio1.value === 'sl' && (sl_total_epochs.value < 1 || sl_total_epochs.value > 100 || sl_total_epochs.value === undefined || sl_total_epochs.value === '')) {
    ElMessage.error("Epochs for sparse learning must be a number not smaller than 1 and not exceeding 100!")
  } else if (iterative_steps.value < 1 || iterative_steps.value > 400 || iterative_steps.value === undefined || iterative_steps.value === '') {
    ElMessage.error("Iterative steps for pruning must be a number not smaller than 1 and not exceeding 400!")
  } else if (finetune.value === '') {
    ElMessage.error("Choose whether to fine-tune!")
    // isNaN()函数用于判断给定的值是否是一个数字。Number.isInteger()函数用于检测给定的值是否是一个整数
  } else if (finetune.value === 'True' && (epoch.value === undefined || epoch.value === null || isNaN(epoch.value) || !Number.isInteger(Number(epoch.value)))) {
    ElMessage.error("Input/Correct the number of epochs for finetuning!")
  } else if (finetune.value === 'True' && (client.value === '')) {
    ElMessage.error("Client is required for Prune-Finetune Task!")
  } else if (finetune.value === 'True' && (finetunemode.value === 'DDP')) {
    ElMessage.error("CIFAR do not support DDP")
  } else {
    let modelname = ''

    if (modelName.value === "ResNet56(tiny)") {
      modelname = "resnet56"
    } else if (modelName.value === "SE-ResNet20") {
      modelname = "se_resnet20"
    } else {
      modelname = modelName.value
    }
    modelname = modelname.toLowerCase()
    let dataroot
    let dataset
    let sl

    if (modelDataset.value === 'CIFAR10 (Classification)') {
      dataroot = '/nfs/lhl/datasets/cifar/cifar-10-batches-py'
      dataset = 'cifar10'
    } else if (modelDataset.value === 'CIFAR100 (Classification)') {
      dataroot = '/nfs/lhl/datasets/cifar/cifar-100-python'
      dataset = 'cifar100'
    } else if (modelDataset.value === 'ImageNet (Classification)') {
      dataroot = '~/datasets/ILSVRC2012/ILSVRC2012/imagenet'
      dataset = 'imagenet'
    } else if (modelDataset.value === 'COCO (Detection)') {
      dataroot = ''
      dataset = 'coco'
    }
    if (radio1.value === "sl") {
      sl = 'True'
    } else if (radio1.value === "wosl") {
      sl = 'False'
    }

    if (finetune.value === 'False') {
      epoch.value = '90'
      client.value = 'NULL'
    }


    // 添加imagenet的DDP脚本
    if (dataset == 'imagenet') {
      if (modelname == 'resnet50') {
        if (finetunemode.value === 'single')
          tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value +" --max-pruning-ratio 0.9 --prune-only"
        else
          tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value + " --distributed --max-pruning-ratio 0.9 --prune-only"
      } else if (modelname == 'densenet121') {
        if (finetunemode.value === 'single')
          tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value
        else
          tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value + " --distributed"
      } else if (modelname == 'mobilenetv2') {
        modelname = 'mobilenet_v2'
        if (finetunemode.value === 'single')
          tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value
        else
          tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value + " --distributed"
      } else if (modelname == 'vgg19_bn' || modelname == 'vgg16_bn') {
        if (finetunemode.value === 'single')
          tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value
        else
          tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs " + epoch.value + " --model " + modelname + " --batch-size " + batchsize.value + " --lr " + lr.value + " --lr-step-size 30 --sl-epochs 30 --sl-lr 0.01 --sl-lr-step-size 10 --prune --cache-dataset --data-path " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --reg 1e-4 --method " + criterion.value + " --global-pruning --soft-keeping-ratio 0.5 --target-flops " + speedup.value + " --global-pruning --print-freq 100 --workers 8 --finetune " + finetune.value + " --client " + client.value + " --distributed"
      } else if (modelname == 'deit_b_16(timm)') {
        if (finetune.value === 'False') {
          tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_deit.py  --test_accuracy --val_batch_size  " + batchsize.value + " --speed-up " + speedup.value + " --mode prune --finetune " + finetune.value + " --pruning_type " + criterion.value + " --client " + client.value
        } else {
          if (finetunemode.value === 'DDP')
            tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/transformers/finetune.py --model " + modelPath.value + " --epochs " + epoch.value + " --pruning_type " + criterion.value + " --batch-size " + batchsize.value + " --opt adamw --lr 0.00015 --wd 0.3 --lr-scheduler cosineannealinglr --lr-warmup-method linear --lr-warmup-epochs 0 --lr-warmup-decay 0.033 --amp --label-smoothing 0.11 --mixup-alpha 0.2 --auto-augment ra --clip-grad-norm 1 --ra-sampler --random-erase 0.25 --cutmix-alpha 1.0  --output-dir output/vit_b_16_pruning_taylor_uniform_v2" + " --finetune " + finetune.value + " --client " + client.value + " --speed-up " + speedup.value + " --model_name deit_b_16(timm) --timm_type deit --distributed --cache-dataset"
        }
      } else if (modelname == 'vit_b_16(timm)') {
        if (finetune.value === 'False') {
          tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_vit.py  --test_accuracy --val_batch_size  " + batchsize.value + " --speed-up " + speedup.value + " --mode prune --finetune " + finetune.value + " --pruning_type " + criterion.value + " --client " + client.value
        } else {
          tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/transformers/finetune.py --model " + modelPath.value + " --epochs " + epoch.value + " --pruning_type " + criterion.value + " --batch-size " + batchsize.value + " --opt adamw --lr 0.00015 --wd 0.3 --lr-scheduler cosineannealinglr --lr-warmup-method linear --lr-warmup-epochs 0 --lr-warmup-decay 0.033 --amp --label-smoothing 0.11 --mixup-alpha 0.2 --auto-augment ra --clip-grad-norm 1 --ra-sampler --random-erase 0.25 --cutmix-alpha 1.0  --output-dir output/vit_b_16_pruning_taylor_uniform_v2" + " --finetune " + finetune.value + " --client " + client.value + " --speed-up " + speedup.value + "  --cache-dataset --distributed"
        }
      } else if (modelname == 'vit_b_16(hf)') {
        if (finetune.value === 'False') {
          tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_hf_vit.py  --test_accuracy --val_batch_size  " + batchsize.value + " --speed-up " + speedup.value + " --mode prune --finetune " + finetune.value + " --pruning_type " + criterion.value + " --client " + client.value
        } else {
          tempScript = "torchrun --nproc_per_node=4 /nfs/lhl/Torch-Pruning/transformers/finetune.py --model " + modelPath.value + " --epochs " + epoch.value + " --pruning_type " + criterion.value + " --batch-size " + batchsize.value + " --opt adamw --lr 0.00015 --wd 0.3 --lr-scheduler cosineannealinglr --lr-warmup-method linear --lr-warmup-epochs 0 --lr-warmup-decay 0.033 --amp --label-smoothing 0.11 --mixup-alpha 0.2 --auto-augment ra --clip-grad-norm 1 --ra-sampler --random-erase 0.25 --cutmix-alpha 1.0  --output-dir output/vit_b_16_pruning_taylor_uniform_v2" + " --finetune " + finetune.value + " --client " + client.value + " --speed-up " + speedup.value + " --model_name vit_b_16(hf) --distributed --cache-dataset"
        }
      }

    } else if (dataset == 'cifar10' || dataset == 'cifar100') {
      tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_system.py --mode prune --model " + modelname + " --batch-size " + batchsize.value + " --restore " + modelPath.value + " --dataroot " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune --pretrain False  --dataset " + dataset + "  --method " + criterion.value + " --speed-up " + speedup.value + " --global-pruning --reg 5e-4 --sl " + sl + " --finetune " + finetune.value + " --total-epochs " + epoch.value + " --client " + client.value + " --iterative-steps " + iterative_steps.value
      if (radio1.value === 'sl') {
        tempScript += " --sl-total-epochs " + sl_total_epochs.value
      }
    } else if (dataset == 'coco') {
      if (modelname == 'yolov7') {
        if (finetune.value === 'False') {
          tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_detect_pruned.py --conf 0.25 --img-size 640  --batch-size " + batchsize.value + " --speed-up " + speedup.value + " --mode prune --finetune " + finetune.value + " --client " + client.value + " --weights " + modelPath.value
        } else {
          tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_train_pruned.py --workers 8 --device 0 --batch-size " + batchsize.value + " --data /nfs/lhl/Torch-Pruning/yolov7/data/coco.yaml --img 640 640 --cfg /nfs/lhl/Torch-Pruning/yolov7/cfg/training/yolov7.yaml " + " --weights " + modelPath.value + " --name yolov7 --hyp /nfs/lhl/Torch-Pruning/yolov7/data/hyp.scratch.p5.yaml" + " --finetune " + finetune.value + " --client " + client.value + " --speed-up " + speedup.value + " --epochs " + epoch.value
        }
      } else if (modelname == 'yolov8')
        tempScript = "python /nfs/lhl/Torch-Pruning/yolov8/yolov8_pruning.py   --batch-size " + batchsize.value + " --speed-up " + speedup.value + " --script-mode prune --finetune " + finetune.value
      else if (modelname == 'yolov5') {
        if (finetune.value === 'False') {
          tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov5_detect_pruned.py --conf 0.25 --img-size 640  --batch-size " + batchsize.value + " --speed-up " + speedup.value + " --mode prune --finetune " + finetune.value + " --client " + client.value + " --weights " + modelPath.value
        } else {
          tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_train_pruned.py --workers 8 --device 0 --batch-size " + batchsize.value + " --data /nfs/lhl/Torch-Pruning/yolov7/data/coco.yaml --img 640 640 --cfg /nfs/lhl/Torch-Pruning/yolov7/cfg/training/yolov7.yaml " + " --weights " + modelPath.value + " --name yolov7 --hyp /nfs/lhl/Torch-Pruning/yolov7/data/hyp.scratch.p5.yaml" + " --finetune " + finetune.value + " --client " + client.value + " --speed-up " + speedup.value + " --epochs " + epoch.value
        }
      }
      // tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_detect_pruned.py --conf 0.25 --img-size 640  --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value+ " --total-epochs " + epoch.value + " --client " + client.value
    }
    // console.log("script.value: ", script.value)
    // tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_system.py --mode prune --model " + modelname + " --batch-size " + batchsize.value + " --restore " + modelPath.value + " --dataroot " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune --pretrain False  --dataset " + dataset + "  --method " + criterion.value + " --speed-up " + speedup.value + " --global-pruning --reg 5e-4 --sl " + sl + " --finetune " + finetune.value


    console.log("tempScript: ", tempScript)
    resultLoading2.value = true
    let success = ''
    resultShow_tree_result.value = false
    flag_prune_done.value = false

    //可能不需要这一步，直接改后端
    // request.post('/algorithm/submitPruneAlgorithm', {
    //   algorithmName: 'cifarAlgorithm',
    //   datasetId: batchsize.value,
    //   datasetName: dataset,
    //   modelName: tempScript,
    //   userName: tempScript,
    // }).then((response) => {
    //   flag = true
    //   //先返回log file, 后面说进度条的事
    //   console.log("prune response.data", response.data)
    //   //下面都删掉,success改为waiting
    //   let arr = response.data.data.result
    //   logPath.value = arr[0]
    //   console.log("logPath:", logPath.value)
    //   // percentage.value = 100
    //   // 取出最后7行
    //   let lastFourRows = arr.slice(-7);
    //
    //   success = lastFourRows[6]
    //
    //   console.log("success:", success)
    //
    //
    //   if (success === 'Success') {
    //     paramsChange.value = lastFourRows[0]
    //     FLOPsChange.value = lastFourRows[1]
    //     AccChange.value = lastFourRows[2]
    //     LossChange.value = lastFourRows[3]
    //     PrunedPath.value = lastFourRows[4]
    //     structureAfterPruned.value = lastFourRows[5]
    //     // logPath.value = lastFourRows[6]
    //     // ElMessage.success('Task completed successfully!')
    //   } else {
    //     paramsChange.value = 'Params: N/A'
    //     FLOPsChange.value = 'FLOPs: N/A'
    //     if(dataset == 'coco'){
    //       AccChange.value = 'mAp: N/A'
    //     }else{
    //       AccChange.value = 'Acc: N/A'
    //     }
    //     LossChange.value = 'Val Loss: N/A'
    //     PrunedPath.value = 'N/A'
    //     structureAfterPruned.value = 'N/A'
    //     // logPath.value = 'N/A'
    //     // ElMessage.error('Task failed!')
    //   }
    //   console.log("paramsChange.value", paramsChange.value)
    //   console.log("FLOPsChange.value", FLOPsChange.value)
    //   console.log("AccChange.value", AccChange.value)
    //   console.log("LossChange.value", LossChange.value)
    //   console.log("PrunedPath.value", PrunedPath.value)
    //   console.log("success:", success)
    //   resultShow_tree_result.value = true
    //   resultLoading4.value = false
    //   flag_prune_done.value = true
    //   // dialogVisible.value = true
    // })
    //     .catch((error) => {
    //       console.error(error)
    //     })
    // logPath.value = 'test_log_path'


    //首先解决date是字符串排序异常的问题
    //存到后端数据库，数据库的history需要增加训练epoch数，当前epoch数，是否为要训练的记录，训练的服务器（前端增加训练的服务器的选择，服务器下要有剩余显存和任务数）

    // 服务器给对应客户端分发任务(服务器也要发消息，但只有有任务的时候才发，不是频繁的心跳包，服务器给客户端发消息的端口应该不同，每个客户端的端口用map存储)

    // 多个客户端一起发消息的实现

    // 客户端数据库表的设计需要任务有是在训练还是在等待还是完成的字段

    // 客户端根据等待时间训练一个

    // 客户端的心跳包需要表面自己的身份（哪个服务器，是否有任务在训练，服务器端口固定50016）


    let taskType = ''

    if (finetune.value === 'False') {
      taskType = 'Directly Pruned'
    } else if (finetune.value === 'True') {
      if (radio1.value === 'sl') {
        taskType = 'Sparse learning --> Pruned --> Fine-tuned'
      } else {
        taskType = 'Pruned --> Fine-tuned'
      }
    }

    // if(dataset == 'coco'){
    //   if (finetune.value === 'False') {
    //     taskType = 'Directly Pruned'
    //   }else if (finetune.value === 'True') {
    //     taskType = 'Pruned --> Fine-tuned'
    //   }
    // }else{
    //   if (radio1.value === 'wosl' && finetune.value === 'False') {
    //     taskType = 'Directly Pruned'
    //   } else if (radio1.value === 'sl' && finetune.value === 'False') {
    //     taskType = 'Sparse learning --> Pruned'
    //   } else if (radio1.value === 'wosl' && finetune.value === 'True') {
    //     taskType = 'Pruned --> Fine-tuned'
    //   } else if (radio1.value === 'sl' && finetune.value === 'True') {
    //     taskType = 'Sparse learning --> Pruned --> Fine-tuned'
    //   }
    // }

    //SubmitTask
    console.log("store.state.access: ", store.state.access)
    if (store.state.access == 0) {
      success = 'Waiting'
      console.log("管理员")
    } else if (store.state.access == 1) {
      success = 'Need Approval'
      console.log("普通用户")
    } else {
      ElMessage.error("Authority error!!")
      return
    }

    let temp1 = {
      username: store.state.username + " " + epoch.value + " " + criterion.value,
      modelname: modelName.value + "-" + modelDatasetSimple.value + "-" + modelTypeSimple.value,
      tasktype: taskType,
      checkpointpath: modelPath.value,
      status: success,
      paramschange: 'Params: N/A',
      flopschange: 'FLOPs: N/A',
      accchange: 'Acc: N/A',
      losschange: 'Val Loss: N/A',
      prunedpath: 'N/A',
      structurebeforepruned: structureBeforePruned.value,
      structureafterpruned: 'N/A',
      logpath: 'N/A',
      script: tempScript,
      client: client.value
    };
    // console.log("history record:", temp1)
    let task_id
    await request.post(`/user/SubmitTrainingHistory`, temp1)
        .then((response) => {
          // console.log("temp1: ", temp1)
          if (response.status === 200) {
            if (success === 'Waiting') {
              ElMessage({
                showClose: true,
                message: 'Pruning task has been submitted.',
                type: 'success',
                duration: 6000
              })
            }else{
              console.log("response: ", response)
              console.log("taskId: ", response.data.data.taskId)
              task_id = response.data.data.taskId
            }
          }
        })
        .catch((errors) => {
          // if (success === 'Waiting') {
            ElMessage({
              showClose: true,
              message: 'Sorry, task submission has failed.',
              type: 'error',
              duration: 6000
            })
          // }
          console.log('error', errors)
        })


    if (success === 'Need Approval') { //普通用户需要提交任务
      let temp = {
        username: store.state.username,
        name: 'N/A',  //算法名称
        score: score.value,
        institute: store.state.institute,
        ranking: task_id,
        morfPath: 'pruning task',
        lerfPath: 'N/A', //提交的算法类型
        pythonPath: "pythonPath",
        email: Email.value,
        info: tempScript,
      };

      console.log("temp1: ", temp)
      await request.post(`/user/SubmitAlgorithm`, temp)
          .then((response) => {
            // console.log("temp1: ", temp1)
            if (response.status === 200) {
              ElMessage.success('Pruning task has been submitted, but need approval.')
            } else {
              ElMessage.error('Sorry, task submission has failed.')
            }
          })
          .catch((errors) => {
            // console.log("temp1: ", temp1)
            ElMessage.success('Sorry, task submission has failed.')
            console.log('error', errors)
          })

    }


    resultLoading2.value = false
    PrunedialogVisible.value = false
    PruneCOCOdialogVisible.value = false
    ImageNetPrunedialogVisible.value = false
    LeafNodeVisible.value = false


  }
}

//OnlinePruning
const updateTree =  async () => {
  // resultLoading.value = true
  // jumpOut.value = false
  // isTest.value = false
  let modelname = ''
  if (modelName.value === "ResNet56(tiny)") {
    modelname = "resnet56"
  } else if (modelName.value === "SE-ResNet20") {
    modelname = "se_resnet20"
  } else {
    modelname = modelName.value
  }
  modelname = modelname.toLowerCase()
  let dataroot
  let dataset
  if (modelDataset.value === 'CIFAR10 (Classification)') {
    dataroot = '/nfs/lhl/datasets/cifar/cifar-10-batches-py'
    dataset = 'cifar10'
  } else if (modelDataset.value === 'CIFAR100 (Classification)') {
    dataroot = '/nfs/lhl/datasets/cifar/cifar-100-python'
    dataset = 'cifar100'
  }else if(modelDataset.value==='ImageNet (Classification)'){
    dataroot = '/nfs/lhl/datasets/ILSVRC2012'
    dataset = 'imagenet'
  }else if(modelDataset.value==='COCO (Detection)'){
    dataroot = ''
    dataset = 'coco'
  }
  let tempScript
  if(dataset == 'imagenet'){
    if(modelname=='resnet50'){
      tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode test_prune --pretrained --epochs 90 --model "+modelname+" --batch-size 128 --lr 0.01 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method group_norm --global-pruning --soft-keeping-ratio 0.5 --target-flops 2.1 --global-pruning --print-freq 100 --finetune False --max-pruning-ratio 0.9 --prune-only"
    }else if(modelname=='densenet121'){
      tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode test_prune --pretrained --epochs 90 --model "+modelname+" --batch-size 128 --lr 0.01 --lr-step-size 30 --sl-lr-step-size 10 --prune --cache-dataset --reg 1e-4 --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method group_norm --soft-keeping-ratio 0.25 --target-flops 2.1 --global-pruning --print-freq 100 --workers 16 --amp --finetune False"
    }else if(modelname=='mobilenetv2'){
      tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode test_prune --pretrained --epochs 90 --model "+modelname+" --batch-size 128 --lr 0.01 --wd 0.00004 --lr-step-size 1 --lr-gamma 0.98 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method group_norm --global-pruning --soft-keeping-ratio 0.5 --target-flops 2.1 --finetune False"
    }else if(modelname=='vgg19_bn'||modelname=='vgg16_bn'){
      tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode test_prune --pretrained --epochs 90 --model "+modelname+" --batch-size 128 --lr 0.01 --wd 0.00004 --lr-step-size 1 --lr-gamma 0.98 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  ---method group_norm --global-pruning --soft-keeping-ratio 0.5 --target-flops 2.1 --finetune False"
    }else if(modelname=='deit_b_16(timm)'){
      tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_deit.py --mode test_prune --val_batch_size 128 --restore " + ckpt.value
    }else if(modelname=='vit_b_16(timm)'){
      tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_vit.py --mode test_prune --val_batch_size 128 --restore "+ ckpt.value
    }else if(modelname=='vit_b_16(hf)'){
      tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_hf_vit.py --mode test_prune --val_batch_size 128 --restore "+ ckpt.value
    }

    // deit_b_16(timm)  vit_b_16(timm)  vit_b_16(hf)

  }else if(dataset == 'cifar10' || dataset == 'cifar100'){
    tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_system.py --mode test_prune --model " + modelname + " --batch-size 128 --restore " + ckpt.value + " --dataroot " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune --pretrain False  --dataset " + dataset + "  --method group_norm --speed-up 2.1 --global-pruning --reg 5e-4 --sl False --finetune False"
  }else if(dataset == 'coco'){
    if(modelname == 'yolov7'){
      tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_detect_pruned.py --conf 0.25 --img-size 640  --batch-size 32 --speed-up 2.0 --mode test_prune --finetune False --weights " + ckpt.value
    }
    else if(modelname == 'yolov8')
    {
      console.log("modelname is",modelname)
      tempScript = "python /nfs/lhl/Torch-Pruning/yolov8/yolov8_pruning.py  --batch-size 32 --speed-up 2.0 --script-mode test_prune --finetune False  "
    }
    else if(modelname == 'yolov5' )
    {
    console.log("modelname is",modelname)
    tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov5_detect_pruned.py --conf 0.25 --img-size 640  --batch-size 32 --speed-up 2.0 --mode test_prune --finetune False --weights " + ckpt.value
    }
  }

  


  // /nfs/lhl/Torch-Pruning/yolov8/yolov8_pruning.py

  console.log("uploadTree: ", tempScript)





  if(ckpt.value === ''){
    console.log("modelName.value", modelName.value)
    console.log("modelDatasetSimple.value", modelDatasetSimple.value)
    ElMessage.error('Please upload a model or provide the model path on the server')
  }else if(usrModelName.value===''){
    ElMessage.error('Please give your model a name')
  }else{
    //SubmitTask
    let success: string
    let task_id
    console.log("store.state.access: ", store.state.access)
    if (store.state.access == 0) {
      success = 'Waiting'
      console.log("管理员")
    } else if (store.state.access == 1) {
      success = 'Need Approval'
      console.log("普通用户")
    } else {
      ElMessage.error("Authority error!!")
      return
    }

    let temp1 = {
      username: store.state.username,
      name: modelName.value,
      score: "",
      institute: modelDatasetSimple.value,
      ranking: "",
      morfPath: ckpt.value,
      lerfPath: usrModelName.value,
      pythonPath: tempScript,
      email: structureBeforePruned.value,
      info: success,
    };
    console.log("temp1: ", temp1)
    resultLoading.value = true
    // ElMessage.warning('We are analyzing the model you\'ve submitted and conducting pruning test.')

    ElMessage({
      showClose: true,
      message: 'We will analyze the model you\'ve submitted and conducting pruning test.',
      type: 'warning',
      duration: 5000
    })
    await request.post(`/user/updateJsonTree`, temp1)
        .then((response) => {
          console.log("updateJsonTree response:", response)
          if (response.status === 200){
            if (success === 'Waiting'){
              ElMessage({
                showClose: true,
                message: 'Upload task submitted!',
                type: 'success',
                duration: 10000
              })
            }else{
              console.log("taskId: ", response.data.data.taskId)
              task_id = response.data.data.taskId
            }
            // ElMessage.error('Test failed. Please ensure the model format is correct and provide the correct path.')
          }
          // jumpOut.value = true
          // console.log("temp1: ", temp1)
        })
        .catch((errors) => {
          // console.log("temp1: ", temp1)
          // ElMessage.error('Model added failed!')
          ElMessage({
            showClose: true,
            message: 'Task submission failed!',
            type: 'error',
            duration: 10000
          })
          //加转圈？？
          console.log('error', errors)
        })


    if (success === 'Need Approval') { //普通用户需要提交任务
      let temp = {
        username: store.state.username,
        name: 'N/A',  //算法名称
        score: score.value,
        institute: store.state.institute,
        ranking: task_id,
        morfPath: 'upload task',
        lerfPath: 'N/A', //提交的算法类型
        pythonPath: "pythonPath",
        email: Email.value,
        info: tempScript,
      };

      console.log("temp1: ", temp)
      await request.post(`/user/SubmitAlgorithm`, temp)
          .then((response) => {
            // console.log("temp1: ", temp1)
            if (response.status === 200) {
              ElMessage.success('Pruning task has been submitted, but need approval.')
            } else {
              ElMessage.error('Sorry, task submission has failed.')
            }
          })
          .catch((errors) => {
            // console.log("temp1: ", temp1)
            ElMessage.success('Sorry, task submission has failed.')
            console.log('error', errors)
          })

    }

    resultLoading.value = false

    UploadVisible.value = false





    // console.log("dataset: ", dataset)
    // //获取进度条
    // let processTimeout = 0;
    // const intervalId = setInterval(() => {
    //   if(jumpOut.value){
    //     clearInterval(intervalId)
    //   }
    //   request.post('/user/getProcess', {
    //     batchSize: 10086,
    //     dataset: dataset
    //   })
    //       .then((response) => {
    //         let process, total, prunnerGot;
    //         process = parseInt(response.data.data.process);
    //         total = parseInt(response.data.data.total);
    //         prunnerGot = response.data.data.prunner
    //         if (process > 0) {
    //           resultLoading.value = false
    //           dialogVisible2.value = true
    //           // resultLoading2.value = false
    //           // resultLoading4.value = true
    //           // dialogVisible_adjust_result.value = true
    //           // resultLoading3.value = false
    //           // resultLoading4.value = true
    //         }
    //         // detectSettingLoading.value=false;
    //         // percentage.value = (1.0 * process / total * 100).toFixed(1).toString()
    //         percentage2.value = (1.0 * process / total * 100).toFixed(1)
    //         console.log("prunnerGot:", prunnerGot)
    //         console.log("process:", process)
    //         console.log("total:", total)
    //         console.log("percentage2.value:", percentage2.value)
    //         if (process == total)
    //           clearInterval(intervalId)
    //       })
    //       .catch((error) => {
    //         processTimeout += 1;
    //         if (processTimeout > 10) {
    //           ElMessage.error('服务器出错，请稍后再试');
    //           clearInterval(intervalId)
    //         }
    //         console.error(error)
    //       })
    // }, 2000)



    // resultShow.value = true

  }

}



// 不再需要了
// const OnlinePruning = () => {
//   isPruned.value = false  //可能改
//   console.log("speedup.value:", speedup.value)
//   let flag = false
//   if(radio1.value!='sl'&&radio1.value!='wosl'){
//     ElMessage.error("Choose whether to employ sparse learning!")
//   }else if(criterion.value===''){
//     ElMessage.error("Select the pruner!")
//   }else if(batchsize.value===0){
//     ElMessage.error("Choose the batch size for sparse learning, evaluation and finetuning!")
//   }else if(speedup.value<=1||speedup.value>10||speedup.value===undefined){
//     ElMessage.error("Speedup must be a number greater than 1 and not exceeding 10!")
//   }else if(finetune.value===''){
//     ElMessage.error("Choose whether to fine-tune!")
//   }else {
//     let modelname = ''
//     if (modelName.value === "ResNet56(tiny)") {
//       modelname = "resnet56"
//     } else if (modelName.value === "SE-ResNet20") {
//       modelname = "se_resnet20"
//     } else {
//       modelname = modelName.value
//     }
//     modelname = modelname.toLowerCase()
//     let dataroot
//     let dataset
//     let sl
//     if (modelDataset.value === 'CIFAR10 (Classification)') {
//       dataroot = '/nfs/lhl/datasets/cifar/cifar-10-batches-py'
//       dataset = 'cifar10'
//     } else if (modelDataset.value === 'CIFAR100 (Classification)') {
//       dataroot = '/nfs/lhl/datasets/cifar/cifar-100-python'
//       dataset = 'cifar100'
//     }else if(modelDataset.value==='ImageNet (Classification)'){
//       dataroot = '/nfs/lhl/datasets/ILSVRC2012'
//       dataset = 'imagenet'
//     }else if(modelDataset.value==='COCO (Detection)'){
//       dataroot = ''
//       dataset = 'coco'
//     }
//     if(radio1.value==="sl"){
//       sl = 'True'
//     }else if(radio1.value==="wosl"){
//       sl = 'False'
//     }
//     let tempScript
//     if(dataset == 'imagenet'){
//       if(modelname=='resnet50'){
//         tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs 90 --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --global-pruning --print-freq 100 --workers 8 --finetune "+finetune.value
//       }else if(modelname=='densenet121'){
//         tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs 90 --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --lr-step-size 30 --sl-lr-step-size 10 --prune --cache-dataset --reg 1e-4 --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --soft-keeping-ratio 0.25 --target-flops "+speedup.value+" --global-pruning --print-freq 100 --workers 16 --amp --finetune "+finetune.value
//       }else if(modelname=='mobilenetv2'){
//         modelname = 'mobilenet_v2'
//         tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs 90 --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --wd 0.00004 --lr-step-size 1 --lr-gamma 0.98 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --finetune "+finetune.value
//       }else if(modelname=='vgg19_bn'||modelname=='vgg16_bn'){
//         tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --epochs 90 --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --wd 0.00004 --lr-step-size 1 --lr-gamma 0.98 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --finetune "+finetune.value
//       }else if(modelname=='deit_b_16(timm)'){
//       tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_deit.py  --test_accuracy --val_batch_size  "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value+" --pruning_type "+criterion.value
//     }else if(modelname=='vit_b_16(timm)'){
//       tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_vit.py  --test_accuracy --val_batch_size  "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value+" --pruning_type "+criterion.value
//     }else if(modelname=='vit_b_16(hf)'){
//       tempScript = "python /nfs/lhl/Torch-Pruning/transformers/prune_hf_vit.py  --test_accuracy --val_batch_size  "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value+" --pruning_type "+criterion.value
//     }
//
//     }else if(dataset == 'cifar10' || dataset == 'cifar100'){
//       tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_system.py --mode prune --model "+modelname+" --batch-size "+batchsize.value+" --restore " + modelPath.value + " --dataroot "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune --pretrain False  --dataset "+dataset+"  --method "+criterion.value+" --speed-up "+speedup.value+" --global-pruning --reg 5e-4 --sl "+sl+" --finetune "+finetune.value
//     }else if(dataset == 'coco'){
//       if(modelname == 'yolov7')
//       tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_detect_pruned.py --conf 0.25 --img-size 640  --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value
//       else if(modelname == 'yolov8')
//       tempScript = "python /nfs/lhl/Torch-Pruning/yolov8/yolov8_pruning.py   --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value
//       else if(modelname == 'yolov5')
//       tempScript = "python /nfs/lhl/Torch-Pruning/yolov7/yolov5_detect_pruned.py --conf 0.25 --img-size 640  --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value
//     }
//
//     // console.log("script.value: ", script.value)
//     // tempScript = "python /nfs/lhl/Torch-Pruning/benchmarks/main_system.py --mode prune --model " + modelname + " --batch-size " + batchsize.value + " --restore " + modelPath.value + " --dataroot " + dataroot + " --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune --pretrain False  --dataset " + dataset + "  --method " + criterion.value + " --speed-up " + speedup.value + " --global-pruning --reg 5e-4 --sl " + sl + " --finetune " + finetune.value
//
//
//
//     console.log("tempScript: ", tempScript)
//     resultLoading2.value = true
//     let success = ''
//     resultShow_tree_result.value = false
//     flag_prune_done.value = false
//     request.post('/algorithm/callPruneAlgorithm', {
//       algorithmName: 'cifarAlgorithm',
//       datasetId: batchsize.value,
//       datasetName: dataset,
//       modelName: tempScript,
//       userName: tempScript,
//     }).then((response) => {
//       console.log("prune response.data", response.data)
//       let arr = response.data.data.result
//       flag = true
//       isPruned.value = true
//       logPath.value = arr[0]
//       console.log("logPath:", logPath.value)
//       // percentage.value = 100
//       // 取出最后7行
//       let lastFourRows = arr.slice(-7);
//
//       success = lastFourRows[6]
//
//       console.log("success:", success)
//
//
//       if (success === 'Success') {
//         paramsChange.value = lastFourRows[0]
//         FLOPsChange.value = lastFourRows[1]
//         AccChange.value = lastFourRows[2]
//         LossChange.value = lastFourRows[3]
//         PrunedPath.value = lastFourRows[4]
//         structureAfterPruned.value = lastFourRows[5]
//         // logPath.value = lastFourRows[6]
//         // ElMessage.success('Task completed successfully!')
//       } else {
//         paramsChange.value = 'Params: N/A'
//         FLOPsChange.value = 'FLOPs: N/A'
//         if(dataset == 'coco'){
//           AccChange.value = 'mAp: N/A'
//         }else{
//           AccChange.value = 'Acc: N/A'
//         }
//         LossChange.value = 'Val Loss: N/A'
//         PrunedPath.value = 'N/A'
//         structureAfterPruned.value = 'N/A'
//         // logPath.value = 'N/A'
//         // ElMessage.error('Task failed!')
//       }
//       console.log("paramsChange.value", paramsChange.value)
//       console.log("FLOPsChange.value", FLOPsChange.value)
//       console.log("AccChange.value", AccChange.value)
//       console.log("LossChange.value", LossChange.value)
//       console.log("PrunedPath.value", PrunedPath.value)
//       console.log("success:", success)
//       resultShow_tree_result.value = true
//       resultLoading4.value = false
//       flag_prune_done.value = true
//       // dialogVisible.value = true
//     })
//         .catch((error) => {
//           console.error(error)
//         })
//
//
//     //获取进度条
//     let processTimeout = 0;
//     const intervalId = setInterval(() => {
//       request.post('/algorithm/getProcess', {
//         batchSize: batchsize.value,
//         dataset: dataset
//       })
//           .then((response) => {
//             let process, total, prunnerGot;
//             process = parseInt(response.data.data.process);
//             total = parseInt(response.data.data.total);
//             prunnerGot = response.data.data.prunner
//             if (process > 0 && !flag_prune_done.value) {
//               dialogVisible.value = true
//               resultLoading2.value = false
//               resultLoading4.value = true
//               // dialogVisible_adjust_result.value = true
//               // resultLoading3.value = false
//               // resultLoading4.value = true
//             }
//             // detectSettingLoading.value=false;
//             // percentage.value = (1.0 * process / total * 100).toFixed(1).toString()
//             percentage.value = (1.0 * process / total * 100).toFixed(1)
//             console.log("prunnerGot:", prunnerGot)
//             console.log("process:", process)
//             console.log("total:", total)
//             console.log("percentage.value:", percentage.value)
//             if (process == total)
//               clearInterval(intervalId)
//           })
//           .catch((error) => {
//             processTimeout += 1;
//             if (processTimeout > 10) {
//               ElMessage.error('服务器出错，请稍后再试');
//               clearInterval(intervalId)
//             }
//             console.error(error)
//           })
//     }, 2000)
//
//     const intervalHistory = setInterval(() => {
//       if (flag) {
//         console.log("flag:", flag)
//         let taskType = ''
//         if(dataset == 'coco'){
//           if (finetune.value === 'False') {
//             taskType = 'Directly Pruned'
//           }else if (finetune.value === 'True') {
//             taskType = 'Pruned --> Fine-tuned'
//           }
//         }else{
//           if (radio1.value === 'wosl' && finetune.value === 'False') {
//             taskType = 'Directly Pruned'
//           } else if (radio1.value === 'sl' && finetune.value === 'False') {
//             taskType = 'Sparse learning --> Pruned'
//           } else if (radio1.value === 'wosl' && finetune.value === 'True') {
//             taskType = 'Pruned --> Fine-tuned'
//           } else if (radio1.value === 'sl' && finetune.value === 'True') {
//             taskType = 'Sparse learning --> Pruned --> Fine-tuned'
//           }
//         }
//
//
//         if (success === 'Success') {
//           success = 'Pruned(completed)'
//         } else {
//           success = 'Failed'
//         }
//
//         // paramsChange.value = lastFourRows[0]
//         // FLOPsChange.value = lastFourRows[1]
//         // AccChange.value = lastFourRows[2]
//         // LossChange.value = lastFourRows[3]
//         // PrunedPath.value = lastFourRows[4]
//         let temp1
//         if (success === 'Pruned(completed)') {
//           temp1 = {
//             username: store.state.username,
//             modelname: modelName.value + "-" + modelDatasetSimple.value + "-" + modelTypeSimple.value,
//             tasktype: taskType,
//             checkpointpath: modelPath.value,
//             status: success,
//             paramschange: paramsChange.value,
//             flopschange: FLOPsChange.value,
//             accchange: AccChange.value,
//             losschange: LossChange.value,
//             prunedpath: PrunedPath.value,
//             structurebeforepruned: structureBeforePruned.value,
//             structureafterpruned: structureAfterPruned.value,
//             logpath: logPath.value
//           };
//         } else {
//           temp1 = {
//             username: store.state.username,
//             modelname: modelName.value + "-" + modelDatasetSimple.value + "-" + modelTypeSimple.value,
//             tasktype: taskType,
//             checkpointpath: modelPath.value,
//             status: success,
//             paramschange: 'Params: N/A',
//             flopschange: 'FLOPs: N/A',
//             accchange: 'Acc: N/A',
//             losschange: 'Val Loss: N/A',
//             prunedpath: 'N/A',
//             structurebeforepruned: structureBeforePruned.value,
//             structureafterpruned: 'N/A',
//             logpath: logPath.value
//           };
//         }
//
//         // paramsChange.value = 'Params: N/A'
//         // FLOPsChange.value = 'FLOPs: N/A'
//         // AccChange.value = 'Acc: N/A'
//         // LossChange.value = 'Val Loss: N/A'
//         // PrunedPath.value = 'N/A'
//         // structureAfterPruned.value = 'N/A'
//
//
//         console.log("history record:", temp1)
//
//         axios.post(`/user/SubmitHistory`, temp1)
//             .then((response) => {
//               // console.log("temp1: ", temp1)
//               if (response.status === 200) {
//                 if (success === 'Pruned(completed)') {
//                   ElMessage({
//                     showClose: true,
//                     message: 'Pruning task has been completed and recorded in history. You can find more information from the log.',
//                     type: 'success',
//                     duration: 6000
//                   })
//                 } else {
//                   ElMessage({
//                     showClose: true,
//                     message: 'Sorry, pruning task failed and has been recorded in history. You can find more information from the log.',
//                     type: 'error',
//                     duration: 6000
//                   })
//                 }
//               }
//             })
//             .catch((errors) => {
//               if (success === 'Pruned(completed)') {
//                 ElMessage({
//                   showClose: true,
//                   message: 'Sorry, pruning task failed and has not been recorded in history. You can find more information from the log.',
//                   type: 'error',
//                   duration: 6000
//                 })
//               } else {
//                 ElMessage({
//                   showClose: true,
//                   message: 'Pruning task has been completed, but something went worng with the server so that it has not been recorded in history. You can find more information from the log.',
//                   type: 'error',
//                   duration: 6000
//                 })
//               }
//               console.log('error', errors)
//             })
//         flag = false
//         // resultLoading2.value = false
//       }
//     }, 2000)
//   }
// }


// 不再需要了
const GenerateScript = () => {
  console.log("speedup.value:", speedup.value)
  if(radio1.value!='sl'&&radio1.value!='wosl'){
    ElMessage.error("Choose whether to employ sparse learning!")
  }else if(criterion.value===''){
    ElMessage.error("Select the pruner!")
  }else if(batchsize.value===0){
    ElMessage.error("Choose the batch size for sparse learning, evaluation and finetuning!")
  }else if(speedup.value<=1||speedup.value>10||speedup.value===undefined){
    ElMessage.error("Speedup must be a number greater than 1 and not exceeding 10!")
  }else if(finetune.value===''){
    ElMessage.error("Choose whether to fine-tune!")
  }else if(finetune.value==='True'&&(epoch.value===undefined||epoch.value===null|| isNaN(epoch.value) || !Number.isInteger(Number(epoch.value)))) {
    ElMessage.error("Input/Correct the number of epochs for finetuning!")
  }else{
    let modelname = ''
    if(modelName.value==="ResNet56(tiny)"){
      modelname = "resnet56"
    }else if(modelName.value==="SE-ResNet"){
      modelname = "se_resnet20"
    }else{
      modelname = modelName.value
    }
    modelname = modelname.toLowerCase()
    let dataroot
    let dataset
    let sl
    if(modelDataset.value==='CIFAR10 (Classification)'){
      dataroot = '/nfs/lhl/datasets/cifar/cifar-10-batches-py'
      dataset = 'cifar10'
    }else if(modelDataset.value==='CIFAR100 (Classification)'){
      dataroot = '/nfs/lhl/datasets/cifar/cifar-100-python'
      dataset = 'cifar100'
    }else if(modelDataset.value==='ImageNet (Classification)'){
      dataroot = '/nfs/lhl/datasets/ILSVRC2012'
      dataset = 'imagenet'
    }else if(modelDataset.value==='COCO (Detection)'){
      dataroot = ''
      dataset = 'coco'
    }
    if(radio1.value==="sl"){
      sl = 'True'
    }else if(radio1.value==="wosl"){
      sl = 'False'
    }
    if(dataset == 'imagenet'){
      if(modelname=='resnet18'){
        script.value = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --global-pruning --print-freq 100 --finetune "+finetune.value+" --max-pruning-ratio 0.9 --prune-only"
      }else if(modelname=='resnet50'){
        script.value = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --global-pruning --print-freq 100 --finetune "+finetune.value+" --max-pruning-ratio 0.9 --prune-only"
      }else if(modelname=='densenet121'){
        script.value = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --lr-step-size 30 --sl-lr-step-size 10 --prune --cache-dataset --reg 1e-4 --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --soft-keeping-ratio 0.25 --target-flops "+speedup.value+" --global-pruning --print-freq 100 --workers 16 --amp --finetune "+finetune.value+" --max-pruning-ratio 0.9 --prune-only"
      }else if(modelname=='mobilenetv2'){
        modelname = 'mobilenet_v2'
        script.value = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --wd 0.00004 --lr-step-size 1 --lr-gamma 0.98 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --finetune "+finetune.value+" --max-pruning-ratio 0.9 --prune-only"
      }else if(modelname=='vgg19_bn'||modelname=='vgg16_bn'){
        script.value = "python /nfs/lhl/Torch-Pruning/benchmarks/main_imagenet.py --mode prune --pretrained --model "+modelname+" --batch-size "+batchsize.value+" --lr " + lr.value + " --wd 0.00004 --lr-step-size 1 --lr-gamma 0.98 --prune --cache-dataset --data-path "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune  --method "+criterion.value+" --global-pruning --soft-keeping-ratio 0.5 --target-flops "+speedup.value+" --finetune "+finetune.value+" --max-pruning-ratio 0.9 --prune-only"
      }else if(modelname=='deit_b_16(timm)'){
        script.value = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_deit.py  --test_accuracy --val_batch_size  "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value + " --pruning_type "+criterion.value
    }else if(modelname=='vit_b_16(timm)'){
      script.value = "python /nfs/lhl/Torch-Pruning/transformers/prune_timm_vit.py  --test_accuracy --val_batch_size  "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value + " --pruning_type "+criterion.value
    }else if(modelname=='vit_s_16(timm)'){
      script.value = "python /nfs/lhl/Torch-Pruning/transformers/finetune.py  --opt adamw --lr 0.00015 --wd 0.3 --lr-scheduler cosineannealinglr --lr-warmup-method linear --lr-warmup-epochs 0 --lr-warmup-decay 0.033 --amp --label-smoothing 0.11 --mixup-alpha 0.2 --auto-augment ra --clip-grad-norm 1 --ra-sampler --random-erase 0.25 --cutmix-alpha 1.0 --output-dir output/vit_small --timm_type vit_small_1k --model_name vit_small_1k --tensorboard --global_pruning --prune  --max-pruning-ratio 0.9  "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value + " --pruning_type "+criterion.value
    }


      if(finetune.value==='True'){
        script.value += " --epoch " + epoch.value
      }

    }else if(dataset == 'cifar10' || dataset == 'cifar100'){
      script.value = "python /nfs/lhl/Torch-Pruning/benchmarks/main_system.py --mode prune --model "+modelname+" --batch-size "+batchsize.value+" --restore " + modelPath.value + " --dataroot "+dataroot+" --output-dir /nfs/lhl/Torch-Pruning/benchmarks/log/prune --pretrain False  --dataset "+dataset+"  --method "+criterion.value+" --speed-up "+speedup.value+" --global-pruning --prune-only --sl "+sl+" --finetune "+finetune.value+" --iterative-steps " + iterative_steps.value
      console.log("importance is",criterion.value)
      if(finetune.value==='True'){
        script.value += " --epoch " + epoch.value
      }

    }else if(dataset == 'coco'){
      console.log("???")
      if(finetune.value==='True'){
        script.value += " --epoch " + epoch.value
      }
      if(modelname == 'yolov7')
      script.value = "python /nfs/lhl/Torch-Pruning/yolov7/yolov7_detect_pruned.py  --conf 0.25 --img-size 640 --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value
      else if(modelname == 'yolov8')
      script.value = "python /nfs/lhl/Torch-Pruning/yolov8/yolov8_pruning.py   --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value
      else if(modelname == 'yolov5')
      script.value = "python /nfs/lhl/Torch-Pruning/yolov7/yolov5_detect_pruned.py  --conf 0.25 --img-size 640 --batch-size "+batchsize.value+" --speed-up "+speedup.value+" --mode prune --finetune "+finetune.value
    }


    console.log("script.value: ", script.value)
    scriptVisible.value = true;
  }


}

// var svgGroup
//以下直到onMounted的代码是把节点转移功能单独提出来
const testHtml = () =>{

  console.log("test: ", test)
}

// var viewerWidth = $(document).height();
// var viewerHeight = $(document).width();
// var duration = 750;
// console.log("fake viewerWidth: ", viewerWidth)
// console.log("fake viewerHeight: ", viewerHeight)
// var response = await request2.post(`/user/getModelZoo`, {});
// var root = response.data;

const treeRoot = ref()

// // click d
// function centerNode(source) {
//   console.log("source: ", source)
//   var zoomListener = d3.behavior
//       .zoom()
//       .scaleExtent([0.1, 3])
//       // .filter(function () {
//       //   return d3.event.ctrlKey;
//       // })
//       .on("zoom", zoom);
//   var scale = zoomListener.scale();
//   var x = -source.y0;
//   var y = -source.x0;
//   x = x * scale + viewerHeight / 8;
//   // x = x * scale + viewerHeight / 20;
//   y = y * scale + viewerHeight / 2;
//   d3.select('g').transition()
//       .duration(duration)
//       .attr("transform", "translate(" + x + "," + y + ")scale(" + scale + ")");
//   zoomListener.scale(scale);
//   zoomListener.translate([x, y]);
// }

function toggleChildren(d) {
  if (d.children) {
    d._children = d.children;
    d.children = null;
  } else if (d._children) {
    d.children = d._children;
    d._children = null;
  }
  return d;
}

//context
async function centerNodebyName(datasetName, modelName){


  //先展开当前节点，在收缩其他节点
  var datasetNode = toggleByDataset(treeRoot.value, datasetName)

  console.log("datasetNode: ", datasetNode)

  // if (d3.event.defaultPrevented) return; // click suppressed



  await update(datasetNode);
  // centerNode(d);




  console.log("treeRoot: ", treeRoot)
  var targetNode = findNodeByDatasetAndModel(treeRoot.value, datasetName, modelName)

  console.log("targetNode: ", targetNode)

  var tryNode = d3.selectAll('.ghostCircle')
  console.log("tryNode: ", tryNode)
  // 使用 filter 方法来选择特定的元素
  const targetGhostCircle = tryNode.filter(function(d) {  // 给圆圈加上红圈特效,新版本只有第一个条件能满足了
    return (d.name === modelName && d.parent.name === datasetName) || (d.parent!=undefined && d.parent.name === modelName && d.parent.parent!=undefined && d.parent.parent.name === datasetName);
  });
  console.log("targetGhostCircle: ", targetGhostCircle)

  // d3.selectAll('.ghostCircle').attr('class', 'ghostCircle show');
  //
  // setTimeout(() => {
  //   d3.selectAll('.ghostCircle').attr('class', 'ghostCircle');
  // }, 1500);

  var tryLink = d3.selectAll('.link')
  console.log("tryLink: ", tryLink)

  const targetLink = tryLink.filter(function(d) {  //新版本不会再出现targetLink了,但是不想删
    return d.source.name === modelName && d.source.parent.name === datasetName;
  });
  console.log("targetLink: ", targetLink)


  centerNode(targetNode)

  // targetGhostCircle.attr('class', 'ghostCircle show');
  // targetLink.attr('class', 'templink');

  setTimeout(() => {
    targetGhostCircle.attr('class', 'ghostCircle show');
    targetLink.attr('class', 'templink');
  }, 200);


  setTimeout(() => {
    targetGhostCircle.attr('class', 'ghostCircle');
    targetLink.attr('class', 'link');
  }, 1500);
}

function findNodeByDatasetAndModel(node, datasetName, modelName) {
  if (node.name === datasetName) {
    // Check if the current node matches the dataset name
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        var child = node.children[i];
        if (child.name === modelName) {
          return child; // Found the model under the specified dataset
        }
      }
    }
  }

  if (node.children) {
    for (var i = 0; i < node.children.length; i++) {
      var result = findNodeByDatasetAndModel(node.children[i], datasetName, modelName);
      if (result) {
        return result;
      }
    }
  }

  return null; // Node not found
}

// function toggleByDataset(node, datasetName) {
//   var datasetNode
//   for (var i = 0; i < node.children.length; i++) {
//     if (node.children[i] === datasetName) {
//       if (!node.children[i].children) {
//         toggleChildren(node.children[i]);
//       }
//     } else {
//       if (node.children[i].children) {
//         toggleChildren(node.children[i]);
//       }
//     }
//   }
//   return datasetNode
// }

function toggleByDataset(node, datasetName) {
  var datasetNode
  for (var i = 0; i < node.children.length; i++) {
    console.log("node.children[i]: ", node.children[i])
    if (node.children[i].name === datasetName){
      console.log("找到了数据集节点")
      datasetNode = node.children[i]
      if(!node.children[i].children){
        console.log("所要求的数据集节点没有孩子，需要扩展出来")
        toggleChildren(node.children[i]);
        // update(node.children[i]);
      }
    }else{
      console.log("这不是要找的数据集节点")
      if(node.children[i].children){
        console.log("该节点有孩子，需要抑制")
        toggleChildren(node.children[i]);
        // update(node.children[i]);
      }
    }
  }
  return datasetNode

  // if (node.name === datasetName) {
  //   // Check if the current node matches the dataset name
  //   return node
  // }
  //
  // if (node.children) {
  //   for (var i = 0; i < node.children.length; i++) {
  //     var result = toggleByDataset(node.children[i], datasetName);
  //     if (result) {
  //       return result;
  //     }
  //   }
  // }

  // return null; // Node not found
}

//迁移标注
var json;
var json_dict = {};
var current_json;
var root;
// var tree;
var maxLabelLength = 0;
var treeData;
var totalNodes = 0;
// variables for drag/drop
var selectedNode = null;
var draggingNode = null;
// panning variables
var panSpeed = 200;
var panBoundary = 20; // Within 20px from edges will pan when dragging.
// Misc. variables
var i = 0;
var duration = 750;
// var root;

// size of the diagram
var viewerWidth = $(document).height();
var viewerHeight = $(document).width();
console.log("real viewerWidth: ", viewerWidth)
console.log("real viewerHeight: ", viewerHeight)

var tree = d3.layout.tree()
    .size([viewerHeight, viewerWidth]);

console.log("tree: ", tree)
// define a d3 diagonal projection for use by the node paths later on.
var diagonal = d3.svg.diagonal()
    .projection(function(d) {
      return [d.y, d.x];
    });

// A recursive helper function for performing some setup by walking through all nodes

function visit(parent, visitFn, childrenFn) {
  if (!parent) return;

  visitFn(parent);

  var children = childrenFn(parent);
  if (children) {
    var count = children.length;
    for (var i = 0; i < count; i++) {
      visit(children[i], visitFn, childrenFn);
    }
  }
}
// sort the tree according to the node names

function sortTree() {
  console.log("执行了此函数")
  console.log(json)
  tree.sort(function(a, b) {
    return b.name.toLowerCase() < a.name.toLowerCase() ? 1 : -1;
  });
}
// define the zoomListener which calls the zoom function on the "zoom" event constrained within the scaleExtents
const zoomListener = d3.behavior
    .zoom()
    .scaleExtent([0.1, 3])
    // .filter(function () {
    //   return d3.event.ctrlKey;
    // })
    .on("zoom", zoom);

// Function to center node when clicked/dropped so node doesn't get lost when collapsing/moving with large amount of children.

function centerNode(source) {
  var scale = zoomListener.scale();
  var x = -source.y0;
  var y = -source.x0;
  x = x * scale + viewerHeight / 4;  //修改以适应最近的树结构
  // x = x * scale + viewerHeight / 20;
  y = y * scale + viewerHeight / 2;
  d3.select('g').transition()
      .duration(duration)
      .attr("transform", "translate(" + x + "," + y + ")scale(" + scale + ")");
  zoomListener.scale(scale);
  zoomListener.translate([x, y]);
}



function zoom() {
  // if (d3.event.sourceEvent.ctrlKey) {
  //   svgGroup.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
  // }
  var svgGroup = d3.select("#tree-container").select("svg").select("g")
  svgGroup.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
}

function pan(domNode, direction) {
  var speed = panSpeed;
  var svgGroup = d3.select("#tree-container").select("svg").select("g")
  if (panTimer) {
    clearTimeout(panTimer);
    var translateCoords = d3.transform(svgGroup.attr("transform"));
    if (direction == 'left' || direction == 'right') {
      var translateX = direction == 'left' ? translateCoords.translate[0] + speed : translateCoords.translate[0] - speed;
      var translateY = translateCoords.translate[1];
    } else if (direction == 'up' || direction == 'down') {
      translateX = translateCoords.translate[0];
      translateY = direction == 'up' ? translateCoords.translate[1] + speed : translateCoords.translate[1] - speed;
    }
    var scaleX = translateCoords.scale[0];
    var scaleY = translateCoords.scale[1];
    var scale = zoomListener.scale();
    svgGroup.transition().attr("transform", "translate(" + translateX + "," + translateY + ")scale(" + scale + ")");
    d3.select(domNode).select('g.node').attr("transform", "translate(" + translateX + "," + translateY + ")");
    zoomListener.scale(zoomListener.scale());
    zoomListener.translate([translateX, translateY]);
    var panTimer = setTimeout(function() {
      pan(domNode, speed, direction);
    }, 50);
  }
}


//context
function initiateDrag(d, domNode) {
  var svgGroup = d3.select("#tree-container").select("svg").select("g")
  draggingNode = d;
  d3.select(domNode).select('.ghostCircle').attr('pointer-events', 'none');
  d3.selectAll('.ghostCircle').attr('class', 'ghostCircle show');
  d3.select(domNode).attr('class', 'node activeDrag');

  svgGroup.selectAll("g.node").sort(function(a, b) { // select the parent and sort the path's
    if (a.id != draggingNode.id) return 1; // a is not the hovered element, send "a" to the back
    else return -1; // a is the hovered element, bring "a" to the front
  });
  // if nodes has children, remove the links and nodes
  if (nodes.length > 1) {
    // remove link paths
    var links = tree.links(nodes);
    var nodePaths = svgGroup.selectAll("path.link")
        .data(links, function(d) {
          return d.target.id;
        }).remove();
    // remove child nodes
    var nodesExit = svgGroup.selectAll("g.node")
        .data(nodes, function(d) {
          return d.id;
        }).filter(function(d, i) {
          if (d.id == draggingNode.id) {
            return false;
          }
          return true;
        }).remove();
  }

  // remove parent link
  var parentLink = tree.links(tree.nodes(draggingNode.parent));
  svgGroup.selectAll('path.link').filter(function(d, i) {
    if (d.target.id == draggingNode.id) {
      return true;
    }
    return false;
  }).remove();

  dragStarted = null;
}

// 选择tree-container元素
const container = d3.select('#tree-container');

// 检查是否存在子元素，如果有则删除
if (!container.empty()) {
  container.select('svg').remove();
}


// Define the drag listeners for drag/drop behaviour of nodes.
var dragListener = d3.behavior.drag()
    .on("dragstart", function(d) {
      if (d == root) {
        return;
      }
      dragStarted = true;
      nodes = tree.nodes(d);
      d3.event.sourceEvent.stopPropagation();
      // it's important that we suppress the mouseover event on the node being dragged. Otherwise it will absorb the mouseover event and the underlying node will not detect it d3.select(this).attr('pointer-events', 'none');
    })
    .on("drag", function(d) {
      if (d == root) {
        return;
      }
      if (dragStarted) {
        domNode = this;
        initiateDrag(d, domNode);
      }

      // get coords of mouseEvent relative to svg container to allow for panning
      var relCoords = d3.mouse($('svg').get(0));
      if (relCoords[0] < panBoundary) {
        var panTimer = true;
        pan(this, 'left');
      } else if (relCoords[0] > ($('svg').width() - panBoundary)) {

        panTimer = true;
        pan(this, 'right');
      } else if (relCoords[1] < panBoundary) {
        panTimer = true;
        pan(this, 'up');
      } else if (relCoords[1] > ($('svg').height() - panBoundary)) {
        panTimer = true;
        pan(this, 'down');
      } else {
        try {
          clearTimeout(panTimer);
        } catch (e) {

        }
      }

      d.x0 += d3.event.dy;
      d.y0 += d3.event.dx;
      var node = d3.select(this);
      node.attr("transform", "translate(" + d.y0 + "," + d.x0 + ")");
      updateTempConnector();
    }).on("dragend", function(d) {
      if (d == root) {
        return;
      }
      domNode = this;
      if (selectedNode) {
        // now remove the element from the parent, and insert it into the new elements children
        var index = draggingNode.parent.children.indexOf(draggingNode);
        if (index > -1) {
          draggingNode.parent.children.splice(index, 1);
        }
        if (typeof selectedNode.children !== 'undefined' || typeof selectedNode._children !== 'undefined') {
          if (typeof selectedNode.children !== 'undefined') {
            selectedNode.children.push(draggingNode);
          } else {
            selectedNode._children.push(draggingNode);
          }
        } else {
          selectedNode.children = [];
          selectedNode.children.push(draggingNode);
        }
        // Make sure that the node being added to is expanded so user can see added node is correctly moved
        expand(selectedNode);
        sortTree();
        endDrag();
      } else {
        endDrag();
      }
    });

// Function to update the temporary connector indicating dragging affiliation
var updateTempConnector = function() {
  var svgGroup = d3.select("#tree-container").select("svg").select("g")
  var data = [];
  if (draggingNode !== null && selectedNode !== null) {
    // have to flip the source coordinates since we did this for the existing connectors on the original tree
    data = [{
      source: {
        x: selectedNode.y0,
        y: selectedNode.x0
      },
      target: {
        x: draggingNode.y0,
        y: draggingNode.x0
      }
    }];
  }
  var link = svgGroup.selectAll(".templink").data(data);

  link.enter().append("path")
      .attr("class", "templink")
      .attr("d", d3.svg.diagonal())
      .attr('pointer-events', 'none');

  link.attr("d", d3.svg.diagonal());

  link.exit().remove();
};


function endDrag() {
  selectedNode = null;
  d3.selectAll('.ghostCircle').attr('class', 'ghostCircle');
  d3.select(domNode).attr('class', 'node');
  // now restore the mouseover event or we won't be able to drag a 2nd time
  d3.select(domNode).select('.ghostCircle').attr('pointer-events', '');
  updateTempConnector();
  if (draggingNode !== null) {
    update(root);
    centerNode(draggingNode);
    draggingNode = null;
  }
}

// Helper functions for collapsing and expanding nodes.

function collapse(d) {
  if (d.children) {
    d._children = d.children;
    d._children.forEach(collapse);
    d.children = null;
  }
}

function expand(d) {
  if (d._children) {
    d.children = d._children;
    d.children.forEach(expand);
    d._children = null;
  }
}

function update(source) {
  // Compute the new height, function counts total children of root node and sets tree height accordingly.
  // This prevents the layout looking squashed when new nodes are made visible or looking sparse when nodes are removed
  // This makes the layout more consistent.
  var svgGroup = d3.select("#tree-container").select("svg").select("g")
  console.log("update in click!")
  console.log("source:", source)
  console.log("source.text:", source.text)
  console.log("source._children:", source._children)
  console.log("source.children:", source.children)

  // if(!source.children){
  //   console.log("update in click!")
  // }

  var levelWidth = [1];
  var childCount = function(level, n) {

    if (n.children && n.children.length > 0) {
      if (levelWidth.length <= level + 1) levelWidth.push(0);

      levelWidth[level + 1] += n.children.length;
      n.children.forEach(function(d) {
        childCount(level + 1, d);
      });
    }
  };
  childCount(0, root);
  var newHeight = d3.max(levelWidth) * 105; // 25 pixels per line  /*<><><><><><><><><><><><><><><><><><><><><><><>THIS IS DETERMINING SPACING */
  tree = tree.size([newHeight, viewerWidth]);

  // Compute the new tree layout.
  nodes = tree.nodes(root).reverse();
  var links = tree.links(nodes);

  // Set widths between levels based on maxLabelLength.
  nodes.forEach(function(d) {
    d.y = (d.depth * (maxLabelLength * 10)); //maxLabelLength * 10px
    // alternatively to keep a fixed scale one can set a fixed depth per level
    // Normalize for fixed-depth by commenting out below line
    // d.y = (d.depth * 500); //500px per level.
  });

  // Update the nodes…
  var node = svgGroup.selectAll("g.node")
      .data(nodes, function(d) {
        return d.id || (d.id = ++i);
      });

  // Enter any new nodes at the parent's previous position.
  var nodeEnter = node.enter().append("g")
      .call(dragListener)
      .attr("class", "node")
      .attr("transform", function(d) {
        return "translate(" + source.y0 + "," + source.x0 + ")";
      })
      .on('click', click)
      .on('contextmenu', contextmenu);
  // .on('dblclick', dblclick);

  nodeEnter.append("circle")
      .attr('class', 'nodeCircle')
      .attr("r", 0)
      .style("stroke", function(d) {
        let currenAccess = store.state.access
        if (d.name==='Model Zoo'||(d.parent.name!=='COCO'&&d.parent.name!=='CIFAR10'&&d.parent.name!=='CIFAR100'&&d.parent.name!=='ImageNet'&&d.parent.name!=='PowerGrid'))
          return "black";
        else if (currenAccess===0||(d.name==='ViT_S_16(timm)'||d.name==='YOLOv8'||((d.name==='ResNet18'||d.name==='ResNet50')&&(d.parent.name=='CIFAR100'||d.parent.name=='ImageNet'))||(d.name==='VGG19'&&d.parent.name==='CIFAR100')))
          return "green";
        else
          return "gray";
      })
      // .style("stroke", "black")
      .style("stroke-width", function(d) {
        if (d.name==='Model Zoo'||(d.parent.name!=='COCO'&&d.parent.name!=='CIFAR10'&&d.parent.name!=='CIFAR100'&&d.parent.name!=='ImageNet'&&d.parent.name!=='PowerGrid'))
          return "1.5px";
        else
          return "5px";
      })
      .style("fill", function(d) {
        return d._children ? "lightsteelblue" : "#fff";
      });

  nodeEnter.append("circle")
      .attr('class', 'nodeCircleBorder')
      .attr("r", 0)
      .style("stroke", "rgba(121, 80, 173, 0.5)")
      .style("stroke-width", function(d) {
        if (d.status==='done')
          return "6px";
        else
          return "0";
      })
      .style("fill", "none")


  // click(
  nodeEnter.append("circle")
      .attr('class', 'nodeCircleBorderFailed')
      .attr("r", 0)
      .style("stroke", "#FC7272")
      .style("stroke-width", function(d) {
        if (d.status==='verfailed')
          return "6px";
        else
          return 0;
      })
      .style("fill", "none")


  nodeEnter.append("circle")
      .attr('class', 'nodeCircleBorderUnknown')
      .attr("r", 0)
      .style("stroke", "#808080")
      .style("stroke-width", function(d) {
        if (d.status==='unknown')
          return "6px";
        else
          return 0;
      })
      .style("fill", "none")

  nodeEnter.append("circle")
      .attr('class', 'nodeCircleBorderUnequiped')
      .attr("r", 0)
      .style("stroke", "#FFA722")
      .style("stroke-width", function(d) {
        if (d.status==='unequiped')
          return "6px";
        else
          return 0;
      })
      .style("fill", "none")




  // .style("pointer-events", "none");

  // nodeEnter.append("circle")
  //     .attr('class', 'nodeCircleOuter') // 为外圆添加一个类名
  //     .attr("r", 0)
  //     .style("stroke", "#7950AD") // 外圆颜色为#7950AD
  //     .style("stroke-width", "2px") // 设置外圆线宽为2px
  //     .style("fill", "none"); // 外圆不填充颜色

  nodeEnter.append("text")
      .attr("x", function(d) {
        return d.children || d._children ? -10 : 10;
      })
      .attr("dy", ".35em")
      .attr('class', 'nodeText')
      // .attr('style', 'font-family: Arial;')
      .attr("text-anchor", function(d){
        return d.children || d._children ? "end" : "start";
      })
      .attr("transform", function(d) {
        if(d.name=='VGG19'){
          console.log("找到了VGG19！")
          console.log("d.children", d.children)
          console.log("d._children", d._children)
        }
        console.log("d.name: ", d.name)
        return d.children || d._children ? "rotate(-90)" : "rotate(-30)";
      })
      // .attr("transform", "rotate(-90)")
      .text(function(d) {
        console.log("文字名称: ", d.name)
        return d.name=="Upload" ? "Add a new model" : (d.name=="CIFAR10" ? "C10" : d.name);
      })
      .style("fill-opacity", 0)
      .style("color", "black")
      .style("font-size", "16px")
      .style("font-family", "Arial");

  // phantom node to give us mouseover in a radius around it
  nodeEnter.append("circle")
      .attr('class', 'ghostCircle')
      .attr("r", 30)
      .attr("opacity", 0.2) // change this to zero to hide the target area
      .style("fill", "red")
      .attr('pointer-events', 'mouseover')
      .on("mouseover", function(node) {
        overCircle(node);
      })
      .on("mouseout", function(node) {
        outCircle(node);
      });

  // Update the text to reflect whether node has children or not.
  node.select('text')
      .attr("x", function(d) {
        // console.log("文字名称: ", d.name)
        // console.log("d.name.length: ", d.name.length)
        var len = d.name=="CIFAR10" ? 3 : d.name=="CIFAR100" ? 4 : d.name=="ImageNet" ? 2 : d.name=="PowerGrid" ? 4 : d.name.length;


        return d.children || d._children ? len*8 : 30;
        // return d.children || d._children ? -30 : 30;
      })
      .attr("y", function(d) {
        return d.children || d._children ? -35 : 0;
      })
      .attr("text-anchor", function(d) {
        return d.children || d._children ? "end" : "start";
      })
      .text(function(d) {
        // console.log("文字名称: ", d.name)
        return d.name=="Upload" ? "Upload" : d.name=="CIFAR10" ? "C10" : d.name=="CIFAR100" ? "C100" : d.name=="ImageNet" ? "IN" : d.name=="PowerGrid" ? "Grid" : d.name;
        // return d.name=='Upload' ? "Upload" : d.name;
      });

  console.log("!!!", node.select("circle.nodeCircleBorder"))
  node.select("circle.nodeCircleBorder").attr("r", 24)

  console.log("!!!", node.select("circle.nodeCircleBorderFailed"))
  node.select("circle.nodeCircleBorderFailed").attr("r", 24)

  console.log("!!!", node.select("circle.nodeCircleBorderUnknown"))
  node.select("circle.nodeCircleBorderUnknown").attr("r", 24)

  console.log("!!!", node.select("circle.nodeCircleBorderUnequiped"))
  node.select("circle.nodeCircleBorderUnequiped").attr("r", 24)



  // Change the circle fill depending on whether it has children and is collapsed
  node.select("circle.nodeCircle")
      .attr("r", 20.5) /*<><><><><><><><><><><><><><><><><><><><><><><>THIS IS DETERMINING RADIUS */
      .style("fill", function(d) {
        // console.log("d:",d)
        // console.log("d._children:",d._children)
        if(d.type==="upload"){
          return "url(#upload)";
        }else if(d.type==="pretrained"){
          return "url(#pretrain)";
        }else if(d.type==="usr"){
          return "url(#usr)";
        }else if(d.type==="conv"){
          return "url(#conv)";
        }else if(d.type==="yolo"){
          return "url(#yolo)";
        }else if(d.type==="transformer"){
          return "url(#transformer)";
        }else if(d.type==="vgg"){
          return "url(#vgg)";
        }else if(d.type==="resnet"){
          return "url(#resnet)";
        }else{
          if(d.name==="Model Zoo"){
            console.log("Model Zoo is here")
            return "url(#hl)";
          }else if(d.name==="PowerGrid Dataset"){
            console.log("Grid Model is here")
            return "url(#grid)";
          }else if(d.name==="ImageNet"){
            return "url(#classification)";
          }else if(d.name==="CIFAR10"){
            return "url(#cifar)";
          }else if(d.name==="CIFAR100"){
            return "url(#imgnet)";
          }else if(d.name==="COCO"){
            return "url(#coco)";
          }else if(d.name==="SchemaNet"){
            return "url(#zhf)";
          }else if(d.name==="Dr. Huang"){
            return "url(#hqh)";
          }else if(d.name==="局部解释"){
            return "url(#local)";
          }else if(d.name==="全局解释"){
            return "url(#global2)";
          }else if(d.name==="事后解释性分析"){
            return "url(#post-hoc)";
          }else if(d.name==="可解释建模"){
            return "url(#ad-hoc)";
          }else if(d.name==="注意力机制"){
            return "url(#attention2)";
          }else if(d.name==="神经树"){
            return "url(#tree)";
          }else if(d.name==="概念响应"){
            return "url(#tcav)";
          }else if(d.name==="归因方法"){
            return "url(#saliency)";
          }else if(d.name==="概念原型"){
            return "url(#prototype)";
          }else{
            console.log("Others")
            return "url(#img1)";
          }
        }
        // d._children ? "lightsteelblue" : "url(#img1)";

      });

  // Transition nodes to their new position.
  var nodeUpdate = node.transition()
      .duration(duration)
      .attr("transform", function(d) {
        return "translate(" + d.y + "," + d.x + ")";
      });

  // Fade the text in
  nodeUpdate.select("text")
      .style("fill-opacity", 1);

  // Transition exiting nodes to the parent's new position.
  var nodeExit = node.exit().transition()
      .duration(duration)
      .attr("transform", function(d) {
        return "translate(" + source.y + "," + source.x + ")";
      })
      .remove();

  nodeExit.select("circle")
      .attr("r", 0);

  nodeExit.select("text")
      .style("fill-opacity", 0);

  // Update the links…
  var link = svgGroup.selectAll("path.link")
      .data(links, function(d) {
        return d.target.id;
      });

  // Enter any new links at the parent's previous position.
  link.enter().insert("path", "g")
      .attr("class", "link")
      .attr("d", function(d) {
        var o = {
          x: source.x0,
          y: source.y0
        };
        return diagonal({
          source: o,
          target: o
        });
      });

  // Transition links to their new position.
  link.transition()
      .duration(duration)
      .attr("d", diagonal);

  // Transition exiting nodes to the parent's new position.
  link.exit().transition()
      .duration(duration)
      .attr("d", function(d) {
        var o = {
          x: source.x,
          y: source.y
        };
        return diagonal({
          source: o,
          target: o
        });
      })
      .remove();

  // Stash the old positions for transition.
  nodes.forEach(function(d) {
    d.x0 = d.x;
    d.y0 = d.y;
  });
}

var overCircle = function(d) {
  selectedNode = d;
  updateTempConnector();
};
var outCircle = function(d) {
  selectedNode = null;
  updateTempConnector();
};

var cascaderDataset;
var cascaderModel;

// cascader
async function click(d) {
  console.log("store.state.access: ", store.state.access)
  let currenAccess = store.state.access
  if(currenAccess!==0){
    if (d.name==='Model Zoo'||(d.parent.name!=='COCO'&&d.parent.name!=='CIFAR10'&&d.parent.name!=='CIFAR100'&&d.parent.name!=='ImageNet'&&d.parent.name!=='PowerGrid'))
      console.log("OK")
    else if (d.name==='ViT_S_16(timm)'||d.name==='YOLOv8'||((d.name==='ResNet18'||d.name==='ResNet50')&&(d.parent.name=='CIFAR100'||d.parent.name=='ImageNet'))||(d.name==='VGG19'&&d.parent.name==='CIFAR100'))
      console.log("OK")
    else{
      ElMessage.error("For regular users, we only provide access to tasks corresponding to the published leaderboards.")
      return;
    }
  }


  if(d.name!='Model Zoo' && (d.parent.name=='CIFAR100' || d.parent.name=='CIFAR10' || d.parent.name=='COCO' || d.parent.name=='ImageNet' || d.parent.name=='PowerGrid')){

    // ElMessage.warning("This should be a terminate node......")
    // if(!store.state.isAut){
    //   ElMessage.warning("You need to log in first before submitting your task")
    // }
    LeafNodeVisible.value = true

    cascader_value.value = []

    cascaderDataset = d.parent.name
    cascaderModel = d.name

    let current_key = d.parent.name + "-" + d.name
    let isDisabled = true
    let Currentchildren = []
    let Currentupload = {}
    let Currentpretrained = {}

    current_json = json_dict[current_key];
    console.log("current_json: ", current_json)

    for (const term of current_json){  //不能直接遍历d因为之后会删掉d的子节点们
      console.log("term: ", term)
      if(term.type==='usr'){
        isDisabled = false
        let child = {
          value: term,
          label: term.name,
        }
        Currentchildren.push(child)
        //在Currentchildren中增加child
      }else if(term.type==='upload'){
        Currentupload = term
      }else if(term.type==='pretrained'){
        Currentpretrained = term
      }
    }

    console.log("isDisabled: ", isDisabled)

    cascader_options = [
      {
        value: Currentupload,
        label: 'Upload a raw model',
        disabled: !store.state.isAut,
      },
      {
        value: Currentpretrained,
        label: 'Prune a pretrained model',
        disabled: !store.state.isAut,
      },
      {
        value: 'prune_user',
        label: 'Prune a user-trained model',
        disabled: !store.state.isAut || isDisabled,
        children: Currentchildren,
      },
    ]

    // cascader
  }

  console.log("click d: ", d)
  centerNode(d);
  if(d.type=='pretrained' || d.type=='usr'){  //这个条件在叶子节点采用级联选择器之后就会作废
    radio1.value = 'wosl'  //要不要sparse learing
    criterion.value = ''  //重要性指标
    batchsize.value = 0
    client155_form.value = 'Bar'
    speedup.value = ''
    finetune.value = ''
    epoch.value = null
    client.value = ''
    iterative_steps.value = ''
    sl_total_epochs.value = ''
    scriptVisible.value = false

    console.log("d.parent.parent.name", d.parent.parent.name)
    if(d.parent.parent.name==="CIFAR10"||d.parent.parent.name==="CIFAR100"||d.parent.parent.name==="ImageNet"){
      modelDataset.value = d.parent.parent.name + " (Classification)"
      modelDatasetSimple.value = d.parent.parent.name
    }else if(d.parent.parent.name==="COCO"){
      modelDataset.value = d.parent.parent.name + " (Detection)"
      modelDatasetSimple.value = d.parent.parent.name
    }
    console.log("modelDataset.value", modelDataset.value)




    if(d.type==='pretrained'){
      modelType.value = "Publicly pretrained model"
      modelTypeSimple.value = "Pretrain"
    }else if(d.type==='usr'){
      modelType.value = "User trained model"
      modelTypeSimple.value = d.name
    }

    console.log("d.path", d.path)
    modelPath.value = d.path
    console.log("d.acc", d.acc)
    modelAcc.value = d.acc
    console.log("d.params", d.params)
    modelParams.value = d.params
    console.log("d.flops", d.flops)
    modelFlops.value = d.flops
    console.log("d.parent.name", d.parent.name)
    modelName.value = d.parent.name


    structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
        d.parent.parent.name.toLowerCase()+'_'+d.parent.name.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
    console.log("structureBeforePruned", structureBeforePruned.value)




    if(d.parent.parent.name=='CIFAR100' || d.parent.parent.name=='CIFAR10'){
      PrunedialogVisible.value = true
      // console.log("d.type", d.type)

      // await axios
      //     .post(`/user/getStructureBeforePruned`, {
      //     })
      //     .then((response) => {
      //       let ranks = response.data.data.ranklistinfo
      //       console.log("response.data.data", response.data.data)
      //       console.log("ranks: ", ranks)
      //       servers.value = ranks
      //     })
      //     .catch((errors) => {
      //       console.log('error', errors)
      //     })


      // ElMessage.success("选择了预训练模型！")
    }else if(d.parent.parent.name=='ImageNet'){
      ImageNetPrunedialogVisible.value = true
      console.log("d.type", d.type)
      if(d.parent.name.includes('hf')){
        INtype.value = 'hf';
      }else if(d.parent.name.includes('timm')){
        INtype.value = 'timm';
      }else{
        INtype.value = 'cnn';
      }

      if(d.model_name=='ImageNet_ResNet50_Pretrained' || d.model_name=='ImageNet_DenseNet121_Pretrained'){
        lr.value = 0.08
      }else if(d.model_name=='ImageNet_MobileNetV2_Pretrained'){
        lr.value = 0.045
      }else if(d.model_name=='ImageNet_VGG19-BN_Pretrained' || d.model_name=='ImageNet_VGG16-BN_Pretrained'){
        lr.value = 0.01
      }
      // radio1.value = 'wosl'
      // criterion.value = ''
      // batchsize.value = 0
      // speedup.value = ''
      // finetune.value = ''
      // scriptVisible.value = false

      // if(d.type==='pretrained'){
      //   modelType.value = "Publicly pretrained model"
      //   modelTypeSimple.value = "Pretrain"
      // }else if(d.type==='usr'){
      //   modelType.value = "User trained model"
      //   modelTypeSimple.value = d.name
      // }
      //
      // console.log("d.path", d.path)
      // modelPath.value = d.path
      // console.log("d.acc", d.acc)
      // modelAcc.value = d.acc
      // console.log("d.params", d.params)
      // modelParams.value = d.params
      // console.log("d.flops", d.flops)
      // modelFlops.value = d.flops
      // console.log("d.parent.name", d.parent.name)
      // modelName.value = d.parent.name



      // console.log("d.parent.parent.name", d.parent.parent.name)
      // if(d.parent.parent.name==="CIFAR10"||d.parent.parent.name==="CIFAR100"||d.parent.parent.name==="ImageNet"){
      //   modelDataset.value = d.parent.parent.name + " (Classification)"
      //   modelDatasetSimple.value = d.parent.parent.name
      // }else if(d.parent.parent.name==="COCO"){
      //   modelDataset.value = d.parent.parent.name + " (Detection)"
      //   modelDatasetSimple.value = d.parent.parent.name
      // }

      // structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
      //     d.parent.parent.name.toLowerCase()+'_'+d.parent.name.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
      // console.log("structureBeforePruned", structureBeforePruned.value)
    }else if(d.parent.parent.name=='COCO'){
      // radio1.value = 'wosl'  //要不要sparse learing
      // criterion.value = ''  //重要性指标
      // batchsize.value = 0
      // speedup.value = ''
      // finetune.value = ''
      // scriptVisible.value = false
      PruneCOCOdialogVisible.value = true
      console.log("d.type", d.type)


      // if(d.type==='pretrained'){
      //   modelType.value = "Publicly pretrained model"
      //   modelTypeSimple.value = "Pretrain"
      // }else if(d.type==='usr'){
      //   modelType.value = "User trained model"
      //   modelTypeSimple.value = d.name
      // }
      //
      // console.log("d.path", d.path)
      // modelPath.value = d.path
      // console.log("d.acc", d.acc)
      // modelAcc.value = d.acc
      // console.log("d.params", d.params)
      // modelParams.value = d.params
      // console.log("d.flops", d.flops)
      // modelFlops.value = d.flops
      // console.log("d.parent.name", d.parent.name)
      // modelName.value = d.parent.name


      // console.log("d.parent.parent.name", d.parent.parent.name)
      // if(d.parent.parent.name==="CIFAR10"||d.parent.parent.name==="CIFAR100"||d.parent.parent.name==="ImageNet"){
      //   modelDataset.value = d.parent.parent.name + " (Classification)"
      //   modelDatasetSimple.value = d.parent.parent.name
      // }else if(d.parent.parent.name==="COCO"){
      //   modelDataset.value = d.parent.parent.name + " (Detection)"
      //   modelDatasetSimple.value = d.parent.parent.name
      // }
      // console.log("modelDataset.value", modelDataset.value)

      // structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
      //     d.parent.parent.name.toLowerCase()+'_'+d.parent.name.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
      //
      //
      // console.log("structureBeforePruned", structureBeforePruned.value)
    }else{
      console.log("标记d.parent.parent.name: ", d.parent.parent.name)
    }

    //gpuChartRef
    await request.post('/algorithm/gpuInfoList')
        .then((response)=>{
          console.log(response)
          let originGPUs=response.data.data
          console.log("originGPUs: ", originGPUs)
          gpuInfos.value = originGPUs
          for(let i=0; i<originGPUs.length; i++){
            let option = {
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c}MiB ({d}%)",
                confine: false,
                appendToBody: true,
                // position: function(point, e, dom, size) {
                //   // 1.计算出绘制canvas的容器（dom.parentNode的值）相对于页面顶部的高度。注意需要由相对于浏览器窗口上部的距离 加上 页面卷曲的高度 来计算。
                //   var top = dom.parentNode.getBoundingClientRect().top + (window.scrollY ? window.scrollY : window.pageYOffset)
                //   // 2.计算出canvas外容器相对与浏览器窗口的左侧的距离
                //   var left = dom.parentNode.getBoundingClientRect().left
                //   // 3.因为tooltip内容过多，canvas已经放不下tooltip。所以需要改变tooltip的定位方式为fixed。
                //   dom.style.position = 'fixed'
                //   // 4.计算出left
                //   var resultLeft = point[0] + left + 5 + dom.clientWidth > document.body.clientWidth ? document.body.clientWidth - dom.clientWidth - 20 : point[0] + left + 5
                //   // 5.计算出top
                //   var resultTop = (point[1] + top + dom.clientHeight) < document.body.clientHeight ? point[1] + dom.parentNode.getBoundingClientRect().top : dom.parentNode.getBoundingClientRect().top - dom.clientHeight + point[1]
                //   // 6.返回位置数据 [left, top]
                //   return [resultLeft, resultTop]
                // },

              },
              color:['#ef6567', '#3BA272'],
              series : [
                {
                  name:originGPUs[i].name+' GPU information',
                  type: 'pie' ,
                  radius: '70%',
                  data: [
                    {value: originGPUs[i].tot_memory - originGPUs[i].remain_memory,  name:'Used'},
                    {value: originGPUs[i].remain_memory,  name:'Available'},
                  ],
                  center: ["50%", "50%"],  // 调整饼图中心点位置
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                }
              ]
            }
            optionList.push(option);
          }
          // gpuChart_


          // gpuRemainMem.value = originGPUs.remain_memory
          // gpuTotMem.value = originGPUs.tot_memory
          // console.log("gpuRemainMem: ", gpuRemainMem.value)
          // console.log("gpuTotMem: ", gpuTotMem.value)
        })
        .catch((error)=>{
          console.error(error)
        })

  }else if(d.type=='upload'){  //这个条件在叶子节点采用级联选择器之后就会作废
    ckpt.value = ''
    ckptUploaded.value = false
    uploadType.value = ''
    modelName.value = d.parent.name
    usrModelName.value = ''
    console.log("d.parent.parent.name", d.parent.parent.name)
    if(d.parent.parent.name==="CIFAR10"||d.parent.parent.name==="CIFAR100"||d.parent.parent.name==="ImageNet"){
      structureBeforePruned.value = '/nfs/lhl/Torch-Pruning/benchmarks/model_before_pruned/test/'+
          d.parent.parent.name.toLowerCase()+'_'+d.parent.name.toLowerCase().replace('(tiny)','').replace('-','_')+'_'+'Pretrained.log'
      modelDataset.value = d.parent.parent.name + " (Classification)"
      modelDatasetSimple.value = d.parent.parent.name
    }else if(d.parent.parent.name==="COCO"){
      modelDataset.value = d.parent.parent.name + " (Detection)"
      modelDatasetSimple.value = d.parent.parent.name
    }
    console.log("modelName.value: ", modelName.value)
    console.log("modelDatasetSimple.value: ", modelDatasetSimple.value)
    UploadVisible.value = true
  }else{  //这个条件需要继续保留
    if (d3.event.defaultPrevented) return; // click suppressed
    d = toggleChildren(d);
    update(d);
    centerNode(d);
  }
  // console.log("测试", d);
  // d3.event.stopPropagation();
}

function contextmenu(d) {
  // d3.select(domNode).select('.ghostCircle').attr('pointer-events', 'none');
  // d3.selectAll('.ghostCircle').attr('class', 'ghostCircle show');
  // d3.select(domNode).attr('class', 'node activeDrag');
  domNode = this;
  console.log("domNode: ", domNode)
  console.log("d3.select(domNode): ", d3.select(domNode))


  d3.select(domNode).selectAll('.ghostCircle').attr('class', 'ghostCircle show');

  // 等待半秒钟
  setTimeout(() => {
    d3.select(domNode).selectAll('.ghostCircle').attr('class', 'ghostCircle');
  }, 1500); // 500毫秒等待时间

  event.preventDefault();
  console.log("d.name", d.name);
  if(d.name==="可解释性"){
    showDialog_interp();
  }if(d.name==="可解释建模"){
    showDialog_atenhoc();
  }if(d.name==="事后解释性分析"){
    showDialog_posthoc();
  }if(d.name==="局部解释"){
    showDialog_local();
  }if(d.name==="全局解释"){
    showDialog_global();
  }if(d.name==="注意力机制"){
    showDialog_attention();
  }if(d.name==="神经树"){
    showDialog_tree();
  }if(d.name==="引用概念"){
    showDialog_intro_concept();
  }if(d.name==="Constituent Attention"){
    showDialog_intro_Constituent();
  }
}

//把onmounted里的重复变量提出来，函数也提出来

onMounted(async () => {

  if(!store.state.isAut){
    ElMessage.warning("Online pruning is not available since you have not logged in yet.")
  }

//   //初始化图表
// // let myChart = echarts.init(document.getElementById('gpuChart') );
//   let myChart = echarts.init(ctx.$refs.gpuChartRef);
// // gpuChartRef
// //配置图表的参数
//   let option = {
//     tooltip: {
//       trigger: "item",
//       formatter: "{a} <br/>{b} : {c} ({d}%)",
//     },
//     color:['#ef6567', '#3BA272'],
//     series : [
//       {
//         name:'GPU显存信息',
//         type: 'pie' ,
//         radius: '90%',
//         data: [
//           {value: 40,  name:'已用显存'},
//           {value: 60,  name:'剩余显存'},
//         ],
//         // center: ["40%", "60%"],
//         emphasis: {
//           itemStyle: {
//             shadowBlur: 10,
//             shadowOffsetX: 0,
//             shadowColor: "rgba(0, 0, 0, 0.5)",
//           },
//         },
//       }
//     ]
//   };
// //使用配置项显示图表
//   myChart.setOption(option);



  try {
    const response = await request2.post(`/user/getModelZoo`, {});
    json = response.data;
    console.log("raw json: ", json);
    let currentAccess = store.state.access
    let currentUser = store.state.username
    console.log("currentAccess: ", currentAccess)
    console.log("currentUser: ", currentUser)
    for (const dataset of json.children) {
      for (const network of dataset.children) {
        const key = `${dataset.name}-${network.name}`;
        if(currentAccess!=0&&currentAccess!=1){
          for (const item of network.children){
            network.children = network.children.filter(item => item.type!=='usr');
          }
        }else if(currentAccess==1){
          for (const item of network.children){
            //如果item以currentUser开头则保留这个item
            network.children = network.children.filter(item => item.type!=='usr'||item.name.startsWith(currentUser+":"));
          }
        }
        json_dict[key] = network.children;
        delete network.children;  //删除了之前的叶子节点
      }
    }
    console.log("json_dict: ", json_dict);
  } catch (error) {
    console.log('error', error);
  }
  // console.log('json', json)

  treeRoot.value = json;
  treeData = json;


// Call visit function to establish maxLabelLength
  visit(treeData, function(d) {
    totalNodes++;
    maxLabelLength = Math.max(d.name.length, maxLabelLength);

  }, function(d) {
    return d.children && d.children.length > 0 ? d.children : null;
  });
// Sort the tree initially incase the JSON isn't in a sorted order.
  sortTree();

// TODO: Pan function, can be better implemented.

// define the baseSvg, attaching a class for styling and the zoomListener
  //这个无法移到外面
  var baseSvg = d3.select("#tree-container").append("svg")
      .attr("width", viewerWidth)
      .attr("height", viewerHeight)
      .attr("class", "overlay")
      .call(zoomListener);

  console.log("baseSvg: ", baseSvg)


/////////////////////////////////////////////////
///////////////// IMAGE DEFS ////////////////////
/////////////////////////////////////////////////

  baseSvg.append('defs').append("pattern")
      .attr("id", "img1")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/tool2.jpg")
      .attr("x", -10)
      .attr("y", -14)
      .attr("width", 60)
      .attr("height", 62);

  baseSvg.append('defs').append("pattern")
      .attr("id", "grid")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/grid.png")
      .attr("x", -10)
      .attr("y", -14)
      .attr("width", 60)
      .attr("height", 62);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "local")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/local2.jpg")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", 40)
      .attr("height", 40);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "post-hoc")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/post-hoc.png")
      .attr("x", 0)
      .attr("y", 1)
      .attr("width", 40)
      .attr("height", 40);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "ad-hoc")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/ad-hoc.png")
      .attr("x", 0)
      .attr("y", -9)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "attention2")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/attention2.jpg")
      .attr("x", -5)
      .attr("y", -13)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "prototype")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/prototype.jpg")
      .attr("x", 0)
      .attr("y", -13)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "concept")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/concept.png")
      .attr("x", 2)
      .attr("y", 0)
      .attr("width", 40)
      .attr("height", 40);

  baseSvg.append('defs').append("pattern")
      .attr("id", "classification")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/classification.jpg")
      .attr("x", 0)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 60);

  baseSvg.append('defs').append("pattern")
      .attr("id", "upload")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/upload.png")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", 40)
      .attr("height", 40);

  baseSvg.append('defs').append("pattern")
      .attr("id", "pretrain")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/pre.png")
      .attr("x", 2)
      .attr("y", 0)
      .attr("width", 40)
      .attr("height",40);

  baseSvg.append('defs').append("pattern")
      .attr("id", "usr")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/usr.png")
      .attr("x", 3)
      .attr("y", 0)
      .attr("width", 40)
      .attr("height",40);

  baseSvg.append('defs').append("pattern")
      .attr("id", "conv")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/conv.png")
      .attr("x", -4)
      .attr("y", -2)
      .attr("width", 49)
      .attr("height",44);

  baseSvg.append('defs').append("pattern")
      .attr("id", "vgg")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/vgg.png")
      .attr("x", 2)
      .attr("y", 1)
      .attr("width", 45)
      .attr("height",40);

  baseSvg.append('defs').append("pattern")
      .attr("id", "resnet")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/ResNet.png")
      .attr("x", -10)
      .attr("y", 0)
      .attr("width", 60)
      .attr("height",40);

  baseSvg.append('defs').append("pattern")
      .attr("id", "transformer")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/Transformer.jpg")
      .attr("x", -4)
      .attr("y", -4)
      .attr("width", 49)
      .attr("height",49);

  baseSvg.append('defs').append("pattern")
      .attr("id", "yolo")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/yolo.jpg")
      .attr("x", -4)
      .attr("y", -2)
      .attr("width", 49)
      .attr("height",45);

  baseSvg.append('defs').append("pattern")
      .attr("id", "cifar")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/cifar.jpg")
      .attr("x", 0)
      .attr("y", -5)
      .attr("width", 60)
      .attr("height",60);

  baseSvg.append('defs').append("pattern")
      .attr("id", "imgnet")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/imgnet.jpg")
      .attr("x", -10)
      .attr("y", -5)
      .attr("width", 60)
      .attr("height",60);



  d3.select('svg').append('defs').append("pattern")
      .attr("id", "proxy")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/proxy.png")
      .attr("x", -8)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "disturbance")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/disturb.png")
      .attr("x", 3)
      .attr("y", 4)
      .attr("width", 35)
      .attr("height", 35);



  baseSvg.append('defs').append("pattern")
      .attr("id", "zebra")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/zebra.jpg")
      .attr("x", -10)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 60);

  baseSvg.append('defs').append("pattern")
      .attr("id", "gradient2")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/gradient2.jpg")
      .attr("x", -10)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 60);


  baseSvg.append('defs').append("pattern")
      .attr("id", "saliency")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/saliency.jpg")
      .attr("x", -10)
      .attr("y", -5)
      .attr("width", 60)
      .attr("height", 64);

  baseSvg.append('defs').append("pattern")
      .attr("id", "tcav")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/tcav.jpg")
      .attr("x", -12)
      .attr("y", -3)
      .attr("width", 60)
      .attr("height",50);

  baseSvg.append('defs').append("pattern")
      .attr("id", "tree")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/tree.jpg")
      .attr("x", 0)
      .attr("y", -8)
      .attr("width", 60)
      .attr("height",50);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "global2")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/global2.jpg")
      .attr("x", -10)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 62);


  baseSvg.append('defs').append("pattern")
      .attr("id", "coco")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/coco.jpg")
      .attr("x", -10)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height",60);

  // d3.select('svg').append('defs').append("pattern")
  baseSvg.append('defs').append("pattern")
      .attr("id", "hl")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/vision.jpg")
      .attr("x", -10)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "xmq")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/xmq.jpg")
      .attr("x", -10)
      .attr("y", -14)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "zhf")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/zhf.jpg")
      .attr("x", -10)
      .attr("y", -14)
      .attr("width", 60)
      .attr("height", 60);

  d3.select('svg').append('defs').append("pattern")
      .attr("id", "hqh")
      .attr("patternUnits", "objectBoundingBox")
      .attr("width", "25")
      .attr("height", "25")
      .append("image")
      .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/hqh.jpg")
      .attr("x", 0)
      .attr("y", -10)
      .attr("width", 60)
      .attr("height", 60);

  console.log("d3.select('svg'):",d3.select('svg'))

  // d3.select('svg').append('defs')
  //     .append("pattern")
  //     .attr("id", "img1")
  //     .attr("patternUnits", "userSpaceOnUse") // 设置图案单位为用户坐标系统
  //     .attr("width", "100%") // 相对于用户坐标系，定义图像相对宽度为100%
  //     .attr("height", "100%") // 相对于用户坐标系，定义图像相对高度为100%
  //     .append("image")
  //     .attr("xlink:href", "http://pruning.vipazoo.cn/api/img/background/tool.jpg")
  //     .attr("x", 0)
  //     .attr("y", 0)
  //     .attr("width", "100%") // 图片元素实际宽度为100%用户坐标系统的宽度
  //     .attr("height", "100%"); // 图片元素实际高度为100%用户坐标系统的高度




// Toggle children on click.
  // click suppressed
  // var clicked = false;
  // var clickTimeout;

  // function click(d) {
  //   if (!clicked) {
  //     clicked = true;
  //
  //     // 使用setTiemout来等待300ms
  //     clickTimeout = setTimeout(function() {
  //       // 单击操作逻辑
  //       console.log("Single Click");
  //
  //       // 将clicked重置为false
  //       clicked = false;
  //     }, 300); // 等待300毫秒
  //
  //   } else {
  //     // 取消定时器
  //     clearTimeout(clickTimeout);
  //     clicked = false;
  //
  //     // 双击操作逻辑
  //     console.log("Double Click");
  //   }
  // }

//await






// Append a group which holds all nodes and which the zoom Listener can act upon.
  baseSvg.append("g");

// Define the root
  root = treeData;
  root.x0 = viewerHeight / 2;
  root.y0 = 0;

// Layout the tree initially and center on the root node.
  toggleByDataset(root, "null");
  update(root);
  centerNode(root);

});


function checkFile(file) {
  // const isCSV = file.type === 'text/csv';
  const isSizeValid = file.size / 1024 / 1024 <= 1000; // Convert size from bytes to kilobytes
  // if (!isCSV) {
  //   ElMessage.error('Please upload a CSV file.')
  // }
  if (!isSizeValid) {
    ElMessage.error('Please upload a checkpoint file with a size less than 1GB.')
  }
  checkCsv.value = isSizeValid;
  return isSizeValid;
}

function checkFile2(file) {
  const isCSV = file.type === 'text/csv';
  const isSizeValid = file.size / 1024 <= 500; // Convert size from bytes to kilobytes
  if (!isCSV) {
    ElMessage.error('Please upload a CSV file.')
  }
  if (!isSizeValid) {
    ElMessage.error('Please upload a CSV file with a size less than 500KB.')
  }
  checkCsv2.value = isCSV && isSizeValid;
  return isCSV && isSizeValid;
}

function checkFilePython(file) {
  const isPy = file.name.toLowerCase().endsWith('.py');
  const isSizeValid = file.size / 1024 <= 500; // Convert size from bytes to kilobytes
  if (!isPy) {
    ElMessage.error('Please upload a python file.')
  }
  if (!isSizeValid) {
    ElMessage.error('Please upload a python file with a size less than 500KB.')
  }
  checkPython.value = isPy && isSizeValid;
  return isPy && isSizeValid;
}




// function handleUploadSuccess(response) {
//   ElMessage.success('File uploaded successfully.')
// }
//
// function handleUploadError(err) {
//   ElMessage.error('File upload failed.')
// }

// const handleRemove: UploadProps["onRemove"] = (uploadFile, uploadFiles) => {
//   // console.log(uploadFileList);
//   // const index=uploadFileList.value.findIndex((e)=>{return e===uploadFile})
//   console.log(uploadFile, uploadFiles);
// };
// const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
//   dialogImageUrl.value = uploadFile.url!;
//   dialogVisible.value = true;
//   // console.log("dialogImageUrl.value: ", dialogImageUrl.value)
// };
// 都不需要了
// const handleChange1: UploadProps["onChange"] = (file, fileList) => {
//   uploadFileList.value = fileList;
//   console.log("uploadRef.value: ", uploadRef.value)
//   console.log("uploadFileList.value: ", uploadFileList.value)
//   console.log("checkCsv.value: ", checkCsv.value)
//   uploadCkpt('aaaxiba!')
//   //
//   // if(checkCsv.value){
//   //   uploadCkpt('aaaxiba!')
//   // }
// };
// const handleChange2: UploadProps["onChange"] = (file, fileList) => {
//   uploadFileList2.value = fileList;
//   console.log("uploadFileList2.value:", uploadFileList2.value)
//   console.log("checkCsv2.value: ", checkCsv2.value)
//   if(checkCsv2.value){
//     uploadCsv('lerf')
//   }
// };
// const handleChange3: UploadProps["onChange"] = (file, fileList) => {
//   uploadFileList3.value = fileList;
//   console.log("uploadFileList3.value:", uploadFileList3.value)
//   console.log("checkPython.value: ", checkPython.value)
//   if(checkPython.value){
//     uploadPython()
//   }
// };
//
// async function uploadCkpt(type){
//   let param = new FormData();
//   console.log("uploadFileList: ", uploadFileList);
//   uploadFileList.value.forEach(
//       (val, index) => {
//         param.append("pictures", val.raw);
//         console.log("test", val.raw);
//       }
//   );
//   console.log("datasetId: ", store.state.datasetId);
//   param.append("datasetId", store.state.datasetId);
//   let config = {
//     baseURL: "/api",
//     //baseURL: "http://localhost:7996",
//     timeout: 30000,
//     headers: {
//       "Content-Type": "multipart/form-data" //设置headers
//     }
//   };
//   console.log("param: ", param);
//   await axios
//       .post("/data/uploadCkpts", param, config)
//       .then(res => {
//         console.log("res: ", res);
//         if (res.status === 200) {
//           console.log("yes");
//           let arr = res.data.data.imgpath.split("/")
//           ckpt.value = '/nfs/lhl/Torch-Pruning/benchmarks/usr_model/'+arr[arr.length - 1]
//           console.log("ckpt.value: ", ckpt.value);
//           uploadRef.value.clearFiles();
//           uploadFileList.value = [];
//           ckptUploaded.value = true;
//           ElMessage.success('Model uploaded successfully.')
//         }else{
//           ElMessage.error('Model upload failed.')
//         }
//       })
//       .catch(err => {
//         console.log(err);
//       });
//   // console.log("uploadFileList: ", uploadFileList);
// }

const handleUploadSuccess = (response, uploadFile) =>{
  console.log("response: ", response);
  let arr = response.split("/")
  console.log("arr: ", arr);
  ckpt.value = '/nfs/lhl/Torch-Pruning/benchmarks/usr_model/'+arr[arr.length - 1]
  console.log("ckpt.value: ", ckpt.value);
  ElMessage.success('Model uploaded successfully.')
}

const handleUploadFailed = (response, uploadFile) =>{
  ElMessage.error('Model upload failed.')
}
//
// async function uploadCsv(type){
//   let param = new FormData();
//   if(type=='morf'){
//     console.log("uploadFileList: ", uploadFileList);
//     uploadFileList.value.forEach(
//         (val, index) => {
//           param.append("pictures", val.raw);
//           console.log("test", val.raw);
//         }
//     );
//   }else if(type=='lerf'){
//     console.log("uploadFileList2: ", uploadFileList2);
//     uploadFileList2.value.forEach(
//         (val, index) => {
//           param.append("pictures", val.raw);
//           console.log("test", val.raw);
//         }
//     );
//   }
//   console.log("datasetId: ", store.state.datasetId);
//   param.append("datasetId", store.state.datasetId);
//   let config = {
//     baseURL: "/api",
//     //baseURL: "http://localhost:7996",
//     timeout: 30000,
//     headers: {
//       "Content-Type": "multipart/form-data" //设置headers
//     }
//   };
//   console.log("param: ", param);
//   await axios
//       .post("/data/uploadCsvs", param, config)
//       .then(res => {
//         console.log("res: ", res);
//         if (res.status === 200) {
//           console.log("yes");
//           if(type=='morf'){
//             let arr = res.data.data.imgpath.split("/")
//             morf.value = arr[arr.length - 1]
//             console.log("morf.value: ", morf.value);
//             uploadRef.value.clearFiles();
//             uploadFileList.value = [];
//             morfUploaded.value = true;
//             ElMessage.success('Morf file uploaded successfully.')
//           }else if(type=='lerf'){
//             let arr = res.data.data.imgpath.split("/")
//             lerf.value = arr[arr.length - 1]
//             console.log("lerf.value: ", lerf.value);
//             uploadRef2.value.clearFiles();
//             uploadFileList2.value = [];
//             lerfUploaded.value = true;
//             ElMessage.success('Lerf file uploaded successfully.')
//           }
//         }else{
//           ElMessage.error('File upload failed.')
//         }
//       })
//       .catch(err => {
//         console.log(err);
//       });
//   // console.log("uploadFileList: ", uploadFileList);
// }
//
// async function uploadPython(){
//   let param = new FormData();
//   console.log("uploadFileList3: ", uploadFileList3);
//   uploadFileList3.value.forEach(
//       (val, index) => {
//         param.append("pictures", val.raw);
//         console.log("test", val.raw);
//       }
//   );
//   console.log("datasetId: ", store.state.datasetId);
//   param.append("datasetId", store.state.datasetId);
//   let config = {
//     baseURL: "/api",
//     //baseURL: "http://localhost:7996",
//     timeout: 30000,
//     headers: {
//       "Content-Type": "multipart/form-data" //设置headers
//     }
//   };
//   console.log("param: ", param);
//   await axios
//       .post("/data/uploadCsvs", param, config)
//       .then(res => {
//         console.log("res: ", res);
//         if (res.status === 200) {
//           console.log("yes");
//           let arr = res.data.data.imgpath.split("/")
//           pythonValue.value = arr[arr.length - 1]
//           console.log("pythonValue.value: ", pythonValue.value);
//           uploadRef3.value.clearFiles();
//           uploadFileList3.value = [];
//           pythonUploaded.value = true;
//           ElMessage.success('File uploaded successfully.')
//         }else{
//           ElMessage.error('File upload failed.')
//         }
//       })
//       .catch(err => {
//         console.log(err);
//       });
// }


async function getUsrRank(){
  if(userQuery.value === ''){
    ElMessage.error('Please input the name of your attribution algorithm!')
  }else if(morfUploaded.value == false){
    ElMessage.error('Please upload your morf result!')
  }else if(lerfUploaded.value == false){
    ElMessage.error('Please upload your lerf result!')
  }else{
    ElMessage.success('Information complete, processing......')
    resultLoading.value = true
    await axios
        .post(`/user/getUsrRank`, {
        })
        .then((response) => {
          let ranks = response.data.data.ranklistinfo
          console.log("response.data.data", response.data.data)
          console.log("ranks: ", ranks)
          servers.value = ranks
        })
        .catch((errors) => {
          console.log('error', errors)
        })

    let temp = {
      morfpath: "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + morf.value,
      lerfpath: "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + lerf.value,
    };
    console.log("请求体：", temp);
    await axios
        .post(`/user/getUsrRank2`, temp)
        .then((response) => {
          let ranks = response.data.data.ranklistinfo
          console.log("response.data.data", response.data.data)
          console.log("ranks: ", ranks)
          servers2.value = ranks
          for (let i = 0; i < servers2.value.length; i++) {
            // const element = servers2.value[i];
            // 检查username是否为"The User"
            if (servers2.value[i].username === "The User") {
              // 如果是，则修改contributor、institute和algorithm字段
              servers2.value[i].username = store.state.username;
              servers2.value[i].institute = store.state.institute;
              servers2.value[i].name = userQuery.value;

              score.value = servers2.value[i].score;
              rank.value = servers2.value[i].ranking;
            }
          }

        })
        .catch((errors) => {
          console.log('error', errors)
        })

    resultShow.value = true
    resultLoading.value = false
  }
}


async function SubmitAlgorithm(){
  if(userQuery.value === ''){
    ElMessage.error('Please input the name of your attribution algorithm!')
  }else if(morfUploaded.value == false){
    ElMessage.error('Please upload your morf result!')
  }else if(lerfUploaded.value == false){
    ElMessage.error('Please upload your lerf result!')
  }else if(Email.value == ''){
    ElMessage.error('Please provide your email address!')
  }else if(Infos.value == ''){
    ElMessage.error('Please complete information about your algorithm!')
  }else{
    if(pythonUploaded.value === true){
      ElMessage.success('You choose to submit your algorithm file.')
    }else{
      ElMessage.warning('You choose not to submit your algorithm file.')
    }
    ElMessage.success('Information complete, submitting your algorithm......')
    resultLoading.value = true
    let pythonPath = ''
    if(pythonValue.value==''){
      pythonPath = 'Not Provided'
    }else{
      pythonPath = "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + pythonValue.value
    }
    let temp1 = {
      username: store.state.username,
      name: userQuery.value,
      score: score.value,
      institute: store.state.institute,
      ranking: rank.value,
      morfPath: "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + morf.value,
      lerfPath: "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + lerf.value,
      pythonPath: pythonPath,
      email: Email.value,
      info: Infos.value,
    };
    console.log("temp1: ", temp1)
    await axios
        .post(`/user/SubmitAlgorithm`, temp1)
        .then((response) => {
          // console.log("temp1: ", temp1)
          if (response.status === 200){
            ElMessage.success('Upload algorithm successfully!')
          }else{
            ElMessage.error('Upload algorithm failed!')
          }
        })
        .catch((errors) => {
          // console.log("temp1: ", temp1)
          ElMessage.success('Upload algorithm failed!')
          console.log('error', errors)
        })
    // resultShow.value = true
    resultLoading.value = false
  }
}

function DetermineUser() {
  console.log("确认用户信息")
  console.log("权限: ", store.state.access)
  let temp = {
    username: store.state.username,
    password: 23333,
  };
  console.log(temp);
  request
      .post("/user/findNoPass", temp)
      .then((res) => {
        console.log(res)
        if (res.status === 200) {
          console.log("确认成功")
          const userInfo = res.data.data.userInfo
          store.commit('setInstitute', userInfo.institute)
          console.log("userInfo.institute: ", userInfo.institute)
          console.log("store.state.institute: ", store.state.institute)
        } else{
          console.log("确认失败")
        }
      })
      .catch((err) => {
        console.log((err));
      });

}

DetermineUser()
// ();
// defineExpose({DetermineUser})
// export { DetermineUser };

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_menu, {
            "default-active": "2",
            class: "el-menu-vertical-demo",
            "active-text-color": "#F9BB00",
            collapse: isCollapse.value,
            "collapse-transition": true,
            ellipsis: false,
            onOpen: handleOpen,
            onClose: handleClose,
            style: {"overflow":"scroll"}
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_el_sub_menu, { index: "1" }, {
                title: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (centerNodebyName('CIFAR10', 'Xception'))),
                    index: "1-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Xception ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (centerNodebyName('CIFAR10', 'VGG19'))),
                    index: "1-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("VGG19")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (centerNodebyName('CIFAR10', 'SE-ResNet20'))),
                    index: "1-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("SE-ResNet20")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (centerNodebyName('CIFAR10', 'ResNet56(tiny)'))),
                    index: "1-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ResNet56 (tiny)")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (centerNodebyName('CIFAR10', 'ResNet18'))),
                    index: "1-5"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ResNet18")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (centerNodebyName('CIFAR10', 'MobileNetv2'))),
                    index: "1-6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("MobileNetV2")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (centerNodebyName('CIFAR10', 'InceptionV4'))),
                    index: "1-7"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("InceptionV4")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (centerNodebyName('CIFAR10', 'GoogleNet'))),
                    index: "1-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("GoogleNet")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (centerNodebyName('CIFAR10', 'DenseNet121'))),
                    index: "1-9"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DenseNet121")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "2" }, {
                title: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (centerNodebyName('CIFAR100', 'Xception'))),
                    index: "2-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Xception")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (centerNodebyName('CIFAR100', 'VGG19'))),
                    index: "2-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("VGG19")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (centerNodebyName('CIFAR100', 'SE-ResNet20'))),
                    index: "2-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("SE-ResNet20")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (centerNodebyName('CIFAR100', 'ResNet56(tiny)'))),
                    index: "2-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ResNet56 (tiny)")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (centerNodebyName('CIFAR100', 'ResNet18'))),
                    index: "2-5"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ResNet18")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (centerNodebyName('CIFAR100', 'MobileNetv2'))),
                    index: "2-6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("MobileNetV2")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (centerNodebyName('CIFAR100', 'InceptionV4'))),
                    index: "2-7"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("InceptionV4")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (centerNodebyName('CIFAR100', 'GoogleNet'))),
                    index: "2-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("GoogleNet")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (centerNodebyName('CIFAR100', 'DenseNet121'))),
                    index: "2-9"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DenseNet121")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "3" }, {
                title: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (centerNodebyName('ImageNet', 'ViT_B_16(timm)'))),
                    index: "3-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ViT_base (timm)")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (centerNodebyName('ImageNet', 'ViT_B_16(hf)'))),
                    index: "3-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ViT_base (huggingface)")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (centerNodebyName('ImageNet', 'VGG19_BN'))),
                    index: "3-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("VGG19")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (centerNodebyName('ImageNet', 'VGG16_BN'))),
                    index: "3-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("VGG16")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (centerNodebyName('ImageNet', 'ResNet50'))),
                    index: "3-5"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ResNet50")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (centerNodebyName('ImageNet', 'MobileNetV2'))),
                    index: "3-6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("MobileNetV2")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (centerNodebyName('ImageNet', 'DenseNet121'))),
                    index: "3-7"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DenseNet121")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (centerNodebyName('ImageNet', 'DeiT_B_16(timm)'))),
                    index: "3-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DeiT_base (timm)")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "4" }, {
                title: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (centerNodebyName('COCO', 'YOLOv5'))),
                    index: "4-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("YOLOv5")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (centerNodebyName('COCO', 'YOLOv7'))),
                    index: "4-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("YOLOv7")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (centerNodebyName('COCO', 'YOLOv8'))),
                    index: "4-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("YOLOv8")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["collapse"]),
          _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_13, 512), [
            [_vShow, !isCollapseDiv.value]
          ])
        ]),
        (!isCollapse.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "sidebar-collapser",
              onClick: toggleCollapse
            }, _toDisplayString(myIcon.value), 1))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "sidebar-collapsed",
              onClick: toggleCollapse
            }, _toDisplayString(myIcon2.value), 1)),
        _createVNode(_component_el_main, { style: {"padding":"0"} }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: UploadVisible.value,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((UploadVisible).value = $event)),
      style: {"width":"50%","height":"60%","text-align":"center","overflow":"auto","font-family":"Arial"},
      draggable: true,
      onClose: _cache[33] || (_cache[33] = ($event: any) => (UploadVisible.value = false)),
      "append-to-body": true,
      title: "Add your model to the model zoo"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, " Provide " + _toDisplayString(modelName.value) + " trained on " + _toDisplayString(modelDatasetSimple.value), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: uploadType.value,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((uploadType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "upload",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Upload a model")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "definePath",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Provide model path on the server")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (uploadType.value==='upload')
            ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 0,
                class: "upload-demo",
                drag: "",
                action: "http://pruning.vipazoo.cn/api/data/uploadCkpt",
                "before-upload": checkFile,
                "on-success": handleUploadSuccess,
                "on-error": handleUploadFailed,
                "show-file-list": false,
                style: {"margin":"10px 50px 10px 50px"}
              }, {
                tip: _withCtx(() => [
                  _hoisted_19
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadFilled))
                    ]),
                    _: 1
                  }),
                  _hoisted_18
                ]),
                _: 1
              }))
            : (uploadType.value==='definePath')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_el_input, {
                    modelValue: ckpt.value,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((ckpt).value = $event)),
                    placeholder: "Provide the model path",
                    style: {"margin-left":"50px","border":"0","color":"black","width":"30%"}
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_input, {
              modelValue: usrModelName.value,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((usrModelName).value = $event)),
              placeholder: "Give your model a name",
              style: {"margin-left":"50px","border":"0","color":"black","width":"30%"}
            }, null, 8, ["modelValue"])
          ], 512), [
            [_vShow, uploadType.value!='']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "success",
              plain: "",
              onClick: updateTree
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit a raw model")
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, uploadType.value!='']
          ])
        ])), [
          [_directive_loading, _unref(resultLoading)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: dialogVisible2.value,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((dialogVisible2).value = $event)),
      style: {"width":"40%","height":"20%","overflow":"auto","text-align":"center"},
      draggable: true,
      onClose: _cache[35] || (_cache[35] = ($event: any) => (dialogVisible2.value = false)),
      "append-to-body": true,
      title: "Analyze model and pruning test"
    }, {
      default: _withCtx(() => [
        (!_ctx.isTest)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28)),
        _createVNode(_component_el_progress, {
          "text-inside": true,
          class: "m-2",
          "stroke-width": 26,
          percentage: percentage2.value,
          color: colors
        }, null, 8, ["percentage"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((dialogVisible).value = $event)),
      style: {"width":"50%","height":"55%","overflow":"auto","text-align":"center"},
      draggable: true,
      onClose: _cache[38] || (_cache[38] = ($event: any) => (dialogVisible.value = false)),
      "append-to-body": true,
      title: "Online Pruning Result"
    }, {
      default: _withCtx(() => [
        (!isPruned.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34)),
        _createVNode(_component_el_progress, {
          "text-inside": true,
          class: "m-2",
          "stroke-width": 26,
          percentage: percentage.value,
          color: colors
        }, null, 8, ["percentage"]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle({visibility:resultShow_tree_result.value?'visible':'hidden'})
        }, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("label", _hoisted_36, _toDisplayString(paramsChange.value), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("label", _hoisted_38, _toDisplayString(FLOPsChange.value), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("label", _hoisted_40, _toDisplayString(AccChange.value), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("label", _hoisted_42, _toDisplayString(LossChange.value), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("label", _hoisted_44, [
              _createTextVNode(" Checkpoint(pruned): "),
              (PrunedPath.value!=='N/A')
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    target: "_blank",
                    href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+PrunedPath.value.split('Torch-Pruning').slice(-1)[0],
                    underline: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "success",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Download")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"]))
                : (_openBlock(), _createElementBlock("text", _hoisted_45, " N/A "))
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("label", _hoisted_47, [
              _createTextVNode(" Model structure(pruned): "),
              (structureAfterPruned.value!=='N/A')
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    target: "_blank",
                    href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+structureAfterPruned.value.split('Torch-Pruning').slice(-1)[0],
                    underline: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("View")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"]))
                : (_openBlock(), _createElementBlock("text", _hoisted_48, " N/A "))
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("label", _hoisted_50, [
              _createTextVNode(" Log file: "),
              (logPath.value!=='N/A')
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    target: "_blank",
                    href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+logPath.value.split('Torch-Pruning').slice(-1)[0],
                    underline: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("View")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"]))
                : (_openBlock(), _createElementBlock("text", _hoisted_51, " N/A "))
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "success",
              plain: "",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (dialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("OK")
              ]),
              _: 1
            })
          ])
        ], 4)), [
          [_directive_loading, resultLoading4.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: PrunedialogVisible.value,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((PrunedialogVisible).value = $event)),
      style: {"width":"95%","height":"95%","text-align":"center","overflow":"auto","font-family":"Arial"},
      draggable: true,
      onClose: _cache[56] || (_cache[56] = ($event: any) => (PrunedialogVisible.value = false)),
      "append-to-body": true,
      title: "CIFAR Model Pruning"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("label", _hoisted_55, [
              _createTextVNode(" Name: " + _toDisplayString(modelName.value), 1),
              _hoisted_56,
              _createTextVNode(" Task: " + _toDisplayString(modelDataset.value), 1),
              _hoisted_57,
              _createTextVNode(" Type: " + _toDisplayString(modelType.value), 1),
              _hoisted_58,
              _createTextVNode(" Acc: " + _toDisplayString(modelAcc.value), 1),
              _hoisted_59,
              _createTextVNode(" Params: " + _toDisplayString(modelParams.value), 1),
              _hoisted_60,
              _createTextVNode(" Flops: " + _toDisplayString(modelFlops.value), 1),
              _hoisted_61,
              _createTextVNode(" Checkpoint: "),
              _createVNode(_component_el_link, {
                target: "_blank",
                href: 'http://pruning.vipazoo.cn/api/WorkSpace'+modelPath.value.split('Torch-Pruning').slice(-1)[0],
                underline: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Download")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"]),
              _hoisted_62,
              _createTextVNode(" Model structure: "),
              _createVNode(_component_el_link, {
                target: "_blank",
                href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+structureBeforePruned.value.split('Torch-Pruning').slice(-1)[0],
                underline: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ]),
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_el_radio_group, {
              onClick: _cache[39] || (_cache[39] = ($event: any) => (criterion.value='')),
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: radio1.value,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((radio1).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("With Sparse Learning")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "wosl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Without Sparse Learning (Recommended)")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (radio1.value==='sl')
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, _hoisted_67))
            : _createCommentVNode("", true),
          (radio1.value==='sl')
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createVNode(_component_el_input, {
                  modelValue: sl_total_epochs.value,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((sl_total_epochs).value = $event)),
                  placeholder: "Please input",
                  style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_69,
          _withDirectives(_createElementVNode("div", _hoisted_70, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "slim",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale + BNScale")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "group_slim",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale + GroupLASSO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "group_sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupNorm")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "growing_reg",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GrowingReg")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2_lasso",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupLASSO")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='sl']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_71, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "random",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Random")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l1",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL1")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "fpgm",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FPGM")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "obdc",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OBD-C")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "cp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "thinet",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ThiNet")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hrank",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HRank")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "lamp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("LAMP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "bnscale_only",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "taylor",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("TaylorFO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hessian",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OBD-Hessian")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='wosl']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_72, _hoisted_74, 512), [
            [_vShow, radio1.value!='wosl' && radio1.value!='sl']
          ]),
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: batchsize.value,
              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((batchsize).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "32",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("32")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "64",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("64")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "128",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("128")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _createVNode(_component_el_input, {
              modelValue: speedup.value,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((speedup).value = $event)),
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_79,
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_el_input, {
              modelValue: iterative_steps.value,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((iterative_steps).value = $event)),
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_81,
          _createElementVNode("div", _hoisted_82, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: finetune.value,
              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((finetune).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "True",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("fine-tune")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "False",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("not fine-tune")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, [
              _createVNode(_component_el_radio_group, {
                onClick: _cache[48] || (_cache[48] = ($event: any) => (criterion.value='')),
                style: {"margin-left":"50px","border":"0","color":"black"},
                modelValue: finetunemode.value,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((finetunemode).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "single",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Single GPU")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "DDP",
                    size: "large",
                    border: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DDP (Recommended)")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, finetune.value==='True']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              _createVNode(_component_el_input, {
                modelValue: epoch.value,
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((epoch).value = $event)),
                placeholder: "Please input",
                style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_87,
            _createElementVNode("div", _hoisted_88, [
              _createVNode(_component_el_radio_group, {
                style: {"margin-left":"60px","border":"0","color":"black"},
                modelValue: client155_form.value,
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((client155_form).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "Bar",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bar charts")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "Pie",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Pie charts")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio_group, {
                style: {"margin-left":"50px","border":"0","color":"black","width":"100%","display":"flex","align-items":"flex-start"},
                modelValue: client.value,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((client).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_component_el_radio, {
                      style: {"width":"33%"},
                      label: "vipa155_client1",
                      size: "large",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("vipa155_client1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: gpuInfos.value,
                      style: {"width":"90%"},
                      border: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          fixed: "",
                          prop: "name",
                          label: "GPU"
                        }),
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          prop: "tot_memory",
                          label: "Total Memory"
                        }, {
                          default: _withCtx((props) => [
                            _createTextVNode(_toDisplayString(props.row.tot_memory) + " MiB ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Memory Usage",
                          "min-width": "160",
                          style: {"min-height":"180px"}
                        }, {
                          default: _withCtx((props) => [
                            (client155_form.value==='Bar')
                              ? (_openBlock(), _createBlock(_component_el_progress, {
                                  key: 0,
                                  "text-inside": true,
                                  class: "m-2",
                                  "stroke-width": 26,
                                  percentage: (100*(props.row.tot_memory - props.row.remain_memory)/props.row.tot_memory).toFixed(1),
                                  color: colors
                                }, null, 8, ["percentage"]))
                              : (client155_form.value==='Pie')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: 'gpuChart_' + props.$index,
                                    style: {"width":"100%","height":"160%","text-align":"left","overflow":"visible"},
                                    ref: 'gpuChartRef_' + props.$index
                                  }, null, 8, _hoisted_90))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createVNode(_component_el_radio, {
                      style: {"width":"33%"},
                      label: "vipa155_client2",
                      size: "large",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("vipa155_client2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: gpuInfos.value,
                      style: {"width":"90%"},
                      border: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          fixed: "",
                          prop: "name",
                          label: "GPU"
                        }),
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          prop: "tot_memory",
                          label: "Total Memory"
                        }, {
                          default: _withCtx((props) => [
                            _createTextVNode(_toDisplayString(props.row.tot_memory) + " MiB ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Memory Usage",
                          "min-width": "160",
                          style: {"min-height":"180px"}
                        }, {
                          default: _withCtx((props) => [
                            (client155_form.value==='Bar')
                              ? (_openBlock(), _createBlock(_component_el_progress, {
                                  key: 0,
                                  "text-inside": true,
                                  class: "m-2",
                                  "stroke-width": 26,
                                  percentage: (100*(props.row.tot_memory - props.row.remain_memory)/props.row.tot_memory).toFixed(1),
                                  color: colors
                                }, null, 8, ["percentage"]))
                              : (client155_form.value==='Pie')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: 'gpuChart2_' + props.$index,
                                    style: {"width":"100%","height":"160%","text-align":"left","overflow":"visible"},
                                    ref: 'gpuChartRef2_' + props.$index
                                  }, null, 8, _hoisted_92))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createVNode(_component_el_radio, {
                    label: "Random",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Random")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, finetune.value==='True']
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              plain: "",
              onClick: _cache[53] || (_cache[53] = ($event: any) => (GenerateScript()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Generate Script")
              ]),
              _: 1
            }),
            (radio1.value==='wosl' && finetune.value==='False')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "large",
                  type: "warning",
                  plain: "",
                  onClick: SubmitTask
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Prune-Only Task")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "large",
                  type: "success",
                  plain: "",
                  onClick: SubmitTask
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Prune-Finetune Task")
                  ]),
                  _: 1
                }))
          ]),
          _createElementVNode("div", _hoisted_94, [
            _withDirectives(_createVNode(_component_el_input, {
              modelValue: script.value,
              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((script).value = $event)),
              autosize: "",
              type: "textarea",
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","width":"95%"}
            }, null, 8, ["modelValue"]), [
              [_vShow, scriptVisible.value]
            ])
          ])
        ])), [
          [_directive_loading, resultLoading2.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: LeafNodeVisible.value,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((LeafNodeVisible).value = $event)),
      style: {"width":"20%","height":"30%","text-align":"center","overflow":"auto","font-family":"Arial"},
      draggable: true,
      onClose: _cache[59] || (_cache[59] = ($event: any) => (LeafNodeVisible.value = false)),
      "append-to-body": true,
      title: "Confirm your task"
    }, {
      default: _withCtx(() => [
        (!_unref(store).state.isAut)
          ? (_openBlock(), _createElementBlock("p", _hoisted_95, [
              _createTextVNode(" You need to log in first before "),
              _hoisted_96,
              _createTextVNode(" submitting your task. ")
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_cascader, {
          modelValue: cascader_value.value,
          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((cascader_value).value = $event)),
          options: _unref(cascader_options),
          props: cascader_props,
          onChange: handleCascaderChange
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: PruneCOCOdialogVisible.value,
      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((PruneCOCOdialogVisible).value = $event)),
      style: {"width":"95%","height":"95%","text-align":"center","overflow":"auto","font-family":"Arial"},
      draggable: true,
      onClose: _cache[77] || (_cache[77] = ($event: any) => (PruneCOCOdialogVisible.value = false)),
      "append-to-body": true,
      title: "COCO Model Pruning"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _hoisted_97,
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("label", _hoisted_99, [
              _createTextVNode(" Name: " + _toDisplayString(modelName.value), 1),
              _hoisted_100,
              _createTextVNode(" Task: " + _toDisplayString(modelDataset.value), 1),
              _hoisted_101,
              _createTextVNode(" Type: " + _toDisplayString(modelType.value), 1),
              _hoisted_102,
              _createTextVNode(" mAp: " + _toDisplayString(modelAcc.value), 1),
              _hoisted_103,
              _createTextVNode(" Params: " + _toDisplayString(modelParams.value), 1),
              _hoisted_104,
              _createTextVNode(" Flops: " + _toDisplayString(modelFlops.value), 1),
              _hoisted_105,
              _createTextVNode(" Checkpoint: "),
              _createVNode(_component_el_link, {
                target: "_blank",
                href: 'http://pruning.vipazoo.cn/api/WorkSpace'+modelPath.value.split('Torch-Pruning').slice(-1)[0],
                underline: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Download")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"]),
              _hoisted_106,
              _createTextVNode(" Model structure: "),
              _createVNode(_component_el_link, {
                target: "_blank",
                href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+structureBeforePruned.value.split('Torch-Pruning').slice(-1)[0],
                underline: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ]),
          _hoisted_107,
          _createElementVNode("div", _hoisted_108, [
            _createVNode(_component_el_radio_group, {
              onClick: _cache[60] || (_cache[60] = ($event: any) => (criterion.value='')),
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: radio1.value,
              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((radio1).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("With Sparse Learning")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "wosl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Without Sparse Learning (Recommended)")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (radio1.value==='sl')
            ? (_openBlock(), _createElementBlock("div", _hoisted_109, _hoisted_111))
            : _createCommentVNode("", true),
          (radio1.value==='sl')
            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                _createVNode(_component_el_input, {
                  modelValue: sl_total_epochs.value,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((sl_total_epochs).value = $event)),
                  placeholder: "Please input",
                  style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_113,
          _withDirectives(_createElementVNode("div", _hoisted_114, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "slim",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale + BNScale")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "group_slim",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale + GroupLASSO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "group_sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupNorm")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "growing_reg",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GrowingReg")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2_lasso",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupLASSO")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='sl']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_115, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "random",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Random")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l1",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL1")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "fpgm",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FPGM")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "cp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "thinet",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ThiNet")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hrank",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HRank")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "lamp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("LAMP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "bnscale_only",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "taylor",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("TaylorFO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hessian",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OBD-Hessian")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='wosl']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_116, _hoisted_118, 512), [
            [_vShow, radio1.value!='wosl' && radio1.value!='sl']
          ]),
          _hoisted_119,
          _createElementVNode("div", _hoisted_120, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: batchsize.value,
              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((batchsize).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "32",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("32")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "64",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("64")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "128",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("128")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_121,
          _createElementVNode("div", _hoisted_122, [
            _createVNode(_component_el_input, {
              modelValue: speedup.value,
              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((speedup).value = $event)),
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_123,
          _createElementVNode("div", _hoisted_124, [
            _createVNode(_component_el_input, {
              modelValue: iterative_steps.value,
              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((iterative_steps).value = $event)),
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_125,
          _createElementVNode("div", _hoisted_126, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: finetune.value,
              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((finetune).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "True",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("fine-tune")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "False",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("not fine-tune")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_127,
            _createElementVNode("div", _hoisted_128, [
              _createVNode(_component_el_radio_group, {
                onClick: _cache[69] || (_cache[69] = ($event: any) => (criterion.value='')),
                style: {"margin-left":"50px","border":"0","color":"black"},
                modelValue: finetunemode.value,
                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((finetunemode).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "single",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Single GPU")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "DDP",
                    size: "large",
                    border: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DDP (Recommended)")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, finetune.value==='True']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_129,
            _createElementVNode("div", _hoisted_130, [
              _createVNode(_component_el_input, {
                modelValue: epoch.value,
                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((epoch).value = $event)),
                placeholder: "Please input",
                style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_131,
            _createElementVNode("div", _hoisted_132, [
              _createVNode(_component_el_radio_group, {
                style: {"margin-left":"60px","border":"0","color":"black"},
                modelValue: client155_form.value,
                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((client155_form).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "Bar",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bar charts")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "Pie",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Pie charts")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio_group, {
                style: {"margin-left":"50px","border":"0","color":"black","width":"100%","display":"flex","align-items":"flex-start"},
                modelValue: client.value,
                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((client).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_133, [
                    _createVNode(_component_el_radio, {
                      style: {"width":"33%"},
                      label: "vipa155_client1",
                      size: "large",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("vipa155_client1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: gpuInfos.value,
                      style: {"width":"90%"},
                      border: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          fixed: "",
                          prop: "name",
                          label: "GPU"
                        }),
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          prop: "tot_memory",
                          label: "Total Memory"
                        }, {
                          default: _withCtx((props) => [
                            _createTextVNode(_toDisplayString(props.row.tot_memory) + " MiB ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Memory Usage",
                          "min-width": "160",
                          style: {"min-height":"180px"}
                        }, {
                          default: _withCtx((props) => [
                            (client155_form.value==='Bar')
                              ? (_openBlock(), _createBlock(_component_el_progress, {
                                  key: 0,
                                  "text-inside": true,
                                  class: "m-2",
                                  "stroke-width": 26,
                                  percentage: (100*(props.row.tot_memory - props.row.remain_memory)/props.row.tot_memory).toFixed(1),
                                  color: colors
                                }, null, 8, ["percentage"]))
                              : (client155_form.value==='Pie')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: 'gpuChart_' + props.$index,
                                    style: {"width":"100%","height":"160%","text-align":"left","overflow":"visible"},
                                    ref: 'gpuChartRef_' + props.$index
                                  }, null, 8, _hoisted_134))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createVNode(_component_el_radio, {
                      style: {"width":"33%"},
                      label: "vipa155_client2",
                      size: "large",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("vipa155_client2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: gpuInfos.value,
                      style: {"width":"90%"},
                      border: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          fixed: "",
                          prop: "name",
                          label: "GPU"
                        }),
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          prop: "tot_memory",
                          label: "Total Memory"
                        }, {
                          default: _withCtx((props) => [
                            _createTextVNode(_toDisplayString(props.row.tot_memory) + " MiB ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Memory Usage",
                          "min-width": "160",
                          style: {"min-height":"180px"}
                        }, {
                          default: _withCtx((props) => [
                            (client155_form.value==='Bar')
                              ? (_openBlock(), _createBlock(_component_el_progress, {
                                  key: 0,
                                  "text-inside": true,
                                  class: "m-2",
                                  "stroke-width": 26,
                                  percentage: (100*(props.row.tot_memory - props.row.remain_memory)/props.row.tot_memory).toFixed(1),
                                  color: colors
                                }, null, 8, ["percentage"]))
                              : (client155_form.value==='Pie')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: 'gpuChart2_' + props.$index,
                                    style: {"width":"100%","height":"160%","text-align":"left","overflow":"visible"},
                                    ref: 'gpuChartRef2_' + props.$index
                                  }, null, 8, _hoisted_136))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createVNode(_component_el_radio, {
                    label: "Random",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Random")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, finetune.value==='True']
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              plain: "",
              onClick: _cache[74] || (_cache[74] = ($event: any) => (GenerateScript()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Generate Script")
              ]),
              _: 1
            }),
            (finetune.value==='False')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "large",
                  type: "warning",
                  plain: "",
                  onClick: SubmitTask
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Prune-Only Task")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "large",
                  type: "success",
                  plain: "",
                  onClick: SubmitTask
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Prune-Finetune Task")
                  ]),
                  _: 1
                }))
          ]),
          _createElementVNode("div", _hoisted_138, [
            _withDirectives(_createVNode(_component_el_input, {
              modelValue: script.value,
              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((script).value = $event)),
              autosize: "",
              type: "textarea",
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","width":"95%"}
            }, null, 8, ["modelValue"]), [
              [_vShow, scriptVisible.value]
            ])
          ])
        ])), [
          [_directive_loading, resultLoading2.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: ImageNetPrunedialogVisible.value,
      "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((ImageNetPrunedialogVisible).value = $event)),
      style: {"width":"95%","height":"95%","text-align":"center","overflow":"auto","font-family":"Arial"},
      draggable: true,
      onClose: _cache[97] || (_cache[97] = ($event: any) => (ImageNetPrunedialogVisible.value = false)),
      "append-to-body": true,
      title: "ImageNet Model Pruning"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _hoisted_139,
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("label", _hoisted_141, [
              _createTextVNode(" Name: " + _toDisplayString(modelName.value), 1),
              _hoisted_142,
              _createTextVNode(" Task: " + _toDisplayString(modelDataset.value), 1),
              _hoisted_143,
              _createTextVNode(" Type: " + _toDisplayString(modelType.value), 1),
              _hoisted_144,
              _createTextVNode(" Acc: " + _toDisplayString(modelAcc.value), 1),
              _hoisted_145,
              _createTextVNode(" Params: " + _toDisplayString(modelParams.value), 1),
              _hoisted_146,
              _createTextVNode(" Flops: " + _toDisplayString(modelFlops.value), 1),
              _hoisted_147,
              _createTextVNode(" Checkpoint: "),
              _createVNode(_component_el_link, {
                target: "_blank",
                href: 'http://pruning.vipazoo.cn/api/ckpt'+modelPath.value.split('checkpoints').slice(-1)[0],
                underline: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Download")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"]),
              _hoisted_148,
              _createTextVNode(" Model structure: "),
              _createVNode(_component_el_link, {
                target: "_blank",
                href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+structureBeforePruned.value.split('Torch-Pruning').slice(-1)[0],
                underline: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ]),
          _hoisted_149,
          _createElementVNode("div", _hoisted_150, [
            _createVNode(_component_el_radio_group, {
              onClick: _cache[78] || (_cache[78] = ($event: any) => (criterion.value='')),
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: radio1.value,
              "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((radio1).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("With Sparse Learning")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "wosl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Without Sparse Learning (Recommended)")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (radio1.value==='sl')
            ? (_openBlock(), _createElementBlock("div", _hoisted_151, _hoisted_153))
            : _createCommentVNode("", true),
          (radio1.value==='sl')
            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                _createVNode(_component_el_input, {
                  modelValue: sl_total_epochs.value,
                  "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((sl_total_epochs).value = $event)),
                  placeholder: "Please input",
                  style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_155,
          _withDirectives(_createElementVNode("div", _hoisted_156, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "slim",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale + BNScale")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "group_slim",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale + GroupLASSO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "group_sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupNorm")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "growing_reg",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GrowingReg")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2_lasso",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupLASSO")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='sl' && INtype.value==='cnn']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_157, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "group_sl",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupNorm")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "growing_reg",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GrowingReg")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2_lasso",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2 + GroupLASSO")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='sl' && INtype.value!=='cnn']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_158, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "random",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Random")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l1",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL1")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "fpgm",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FPGM")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "obdc",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OBD-C")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "cp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "thinet",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ThiNet")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hrank",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HRank")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "lamp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("LAMP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "bnscale_only",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BNScale")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "taylor",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("TaylorFO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hessian",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OBD-Hessian")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='wosl' && INtype.value==='cnn']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_159, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: criterion.value,
              "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((criterion).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "random",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Random")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l1",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL1")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "l2",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MagnitudeL2")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "fpgm",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FPGM")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "cp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "thinet",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ThiNet")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "lamp",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("LAMP")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "taylor",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("TaylorFO")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "hessian",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OBD-Hessian")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, radio1.value==='wosl' && INtype.value!=='cnn']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_160, _hoisted_162, 512), [
            [_vShow, radio1.value!='wosl' && radio1.value!='sl']
          ]),
          _hoisted_163,
          _createElementVNode("div", _hoisted_164, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: batchsize.value,
              "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((batchsize).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "4",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("16")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "8",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("32")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "16",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("64")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "32",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("128")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_165,
          _createElementVNode("div", _hoisted_166, [
            _createVNode(_component_el_input, {
              modelValue: speedup.value,
              "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((speedup).value = $event)),
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_167,
          _createElementVNode("div", _hoisted_168, [
            _createVNode(_component_el_input, {
              modelValue: iterative_steps.value,
              "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((iterative_steps).value = $event)),
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_169,
          _createElementVNode("div", _hoisted_170, [
            _createVNode(_component_el_radio_group, {
              style: {"margin-left":"50px","border":"0","color":"black"},
              modelValue: finetune.value,
              "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((finetune).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "True",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("fine-tune")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "False",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("not fine-tune")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_171,
            _createElementVNode("div", _hoisted_172, [
              _createVNode(_component_el_radio_group, {
                onClick: _cache[89] || (_cache[89] = ($event: any) => (criterion.value='')),
                style: {"margin-left":"50px","border":"0","color":"black"},
                modelValue: finetunemode.value,
                "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((finetunemode).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "single",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Single GPU")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "DDP",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DDP (Recommended)")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, finetune.value==='True']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_173,
            _createElementVNode("div", _hoisted_174, [
              _createVNode(_component_el_input, {
                modelValue: epoch.value,
                "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((epoch).value = $event)),
                placeholder: "Please input",
                style: {"margin-left":"50px","border":"0","color":"black","width":"8%"}
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_175,
            _createElementVNode("div", _hoisted_176, [
              _createVNode(_component_el_radio_group, {
                style: {"margin-left":"60px","border":"0","color":"black"},
                modelValue: client155_form.value,
                "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((client155_form).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "Bar",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bar charts")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "Pie",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Pie charts")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio_group, {
                style: {"margin-left":"50px","border":"0","color":"black","width":"100%","display":"flex","align-items":"flex-start"},
                modelValue: client.value,
                "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((client).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_177, [
                    _createVNode(_component_el_radio, {
                      style: {"width":"33%"},
                      label: "vipa155_client1",
                      size: "large",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("vipa155_client1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: gpuInfos.value,
                      style: {"width":"90%"},
                      border: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          fixed: "",
                          prop: "name",
                          label: "GPU"
                        }),
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          prop: "tot_memory",
                          label: "Total Memory"
                        }, {
                          default: _withCtx((props) => [
                            _createTextVNode(_toDisplayString(props.row.tot_memory) + " MiB ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Memory Usage",
                          "min-width": "160",
                          style: {"min-height":"180px"}
                        }, {
                          default: _withCtx((props) => [
                            (client155_form.value==='Bar')
                              ? (_openBlock(), _createBlock(_component_el_progress, {
                                  key: 0,
                                  "text-inside": true,
                                  class: "m-2",
                                  "stroke-width": 26,
                                  percentage: (100*(props.row.tot_memory - props.row.remain_memory)/props.row.tot_memory).toFixed(1),
                                  color: colors
                                }, null, 8, ["percentage"]))
                              : (client155_form.value==='Pie')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: 'gpuChart_' + props.$index,
                                    style: {"width":"100%","height":"160%","text-align":"left","overflow":"visible"},
                                    ref: 'gpuChartRef_' + props.$index
                                  }, null, 8, _hoisted_178))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createElementVNode("div", _hoisted_179, [
                    _createVNode(_component_el_radio, {
                      style: {"width":"33%"},
                      label: "vipa155_client2",
                      size: "large",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("vipa155_client2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: gpuInfos.value,
                      style: {"width":"90%"},
                      border: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          fixed: "",
                          prop: "name",
                          label: "GPU"
                        }),
                        _createVNode(_component_el_table_column, {
                          "min-width": "80",
                          prop: "tot_memory",
                          label: "Total Memory"
                        }, {
                          default: _withCtx((props) => [
                            _createTextVNode(_toDisplayString(props.row.tot_memory) + " MiB ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Memory Usage",
                          "min-width": "160",
                          style: {"min-height":"180px"}
                        }, {
                          default: _withCtx((props) => [
                            (client155_form.value==='Bar')
                              ? (_openBlock(), _createBlock(_component_el_progress, {
                                  key: 0,
                                  "text-inside": true,
                                  class: "m-2",
                                  "stroke-width": 26,
                                  percentage: (100*(props.row.tot_memory - props.row.remain_memory)/props.row.tot_memory).toFixed(1),
                                  color: colors
                                }, null, 8, ["percentage"]))
                              : (client155_form.value==='Pie')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: 'gpuChart2_' + props.$index,
                                    style: {"width":"100%","height":"160%","text-align":"left","overflow":"visible"},
                                    ref: 'gpuChartRef2_' + props.$index
                                  }, null, 8, _hoisted_180))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createVNode(_component_el_radio, {
                    label: "Random",
                    size: "large",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Random")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, finetune.value==='True']
          ]),
          _createElementVNode("div", _hoisted_181, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              plain: "",
              onClick: _cache[94] || (_cache[94] = ($event: any) => (GenerateScript()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Generate Script")
              ]),
              _: 1
            }),
            (finetune.value==='False')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "large",
                  type: "warning",
                  plain: "",
                  onClick: SubmitTask
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Prune-Only Task")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "large",
                  type: "success",
                  plain: "",
                  onClick: SubmitTask
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Prune-Finetune Task")
                  ]),
                  _: 1
                }))
          ]),
          _createElementVNode("div", _hoisted_182, [
            _withDirectives(_createVNode(_component_el_input, {
              modelValue: script.value,
              "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((script).value = $event)),
              autosize: "",
              type: "textarea",
              placeholder: "Please input",
              style: {"margin-left":"50px","border":"0","width":"95%"}
            }, null, 8, ["modelValue"]), [
              [_vShow, scriptVisible.value]
            ])
          ])
        ])), [
          [_directive_loading, resultLoading2.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})